const HOST = process.env.API_HOST || 'https://distflor-gocaw.ondigitalocean.app';
const API_VERSION = 'api/v1';
const buildEndpoint = (path: string) => `${HOST}/${API_VERSION}/${path}`;

export const EndPoints = {
    AUTH: {
        LOGIN: buildEndpoint('auths/login'),
        LOGOUT: buildEndpoint('auths/logout'),
        // PUSHER_AUTH: buildEndpoint('auths/pusher-auth'),
        VALIDATE_TOKEN: buildEndpoint('auths/validate-token'),
        GET_ROLES: buildEndpoint('auths/get-roles'),
        SEND_CODE_RECOVERY_PASSWORD: buildEndpoint('auths/send-code-recovery-password'),
        CHANGE_PASSWORD_BY_CODE: buildEndpoint('auths/change-password-by-code'),
        GET_PROFILE: buildEndpoint('auths/get-profile'),
        UPDATE_PROFILE: buildEndpoint('auths/update-profile'),
        UPDATE_PROFILE_PASSWORD: buildEndpoint('auths/update-profile-password')
    },
    ACTIONS: {
        GET_ACTIONS: buildEndpoint('actions/actions/'),
        EDIT_ACTIONS_BY_GROUP: buildEndpoint('actions/actions/:id/edit-by-group'),
        UPDATE_ACTIONS_BY_GROUP: buildEndpoint('actions/actions/:id/update-by-group'),
    },
    ACCOUNT: {
        GET_ACCOUNTS: buildEndpoint('accounts/accounts'),
        STORE_ACCOUNT: buildEndpoint('accounts/accounts/store'),
        EDIT_ACCOUNT: buildEndpoint('accounts/accounts/:id/edit'),
        CREATE_ACCOUNT: buildEndpoint('accounts/accounts/create'),
        SHOW_ACCOUNT: buildEndpoint('accounts/accounts/:id/show'),
        UPDATE_ACCOUNT: buildEndpoint('accounts/accounts/:id/update'),
        DELETE_ACCOUNT: buildEndpoint('accounts/accounts/:id/delete'),
        ACTIVE_ACCOUNT: buildEndpoint('accounts/accounts/:id/active')
    },
    CALENDAR_REQUESTS: {
        GET_WORKER_CALENDAR_REQUESTS: buildEndpoint('calendars/calendar-requests/:id/by-worker'),
        GET_ALL_CALENDAR_REQUESTS: buildEndpoint('calendars/calendar-requests'),
        CREATE_CALENDAR_REQUESTS: buildEndpoint('calendars/calendar-requests/create'),
        STORE_CALENDAR_REQUESTS: buildEndpoint('calendars/calendar-requests/store'),
        ACTIVE_CALENDAR_REQUESTS: buildEndpoint('calendars/calendar-requests/:id/active'),
        DELETE_CALENDAR_REQUESTS: buildEndpoint('calendars/calendar-requests/:id/delete'),
        WORKER_APPROVED_CALENDAR_REQUESTS: buildEndpoint(
            'calendars/calendar-requests/:id/approved'
        ),
        DOCUMENT_CALENDAR_REQUESTS: buildEndpoint('calendars/calendar-requests/:id/get-document'),
        EDIT_CALENDAR_REQUEST: buildEndpoint('calendars/calendar-requests/:id/edit'),
        UPDATE_CALENDAR_REQUEST: buildEndpoint('calendars/calendar-requests/:id/update')
    },
    EXPENSE_TYPES: {
        GET_EXPENSE_TYPES: buildEndpoint('work-orders/expense-types/:is_system/all-is-system'),
        CREATE_EXPENSE_TYPE: buildEndpoint('work-orders/expense-types/create'),
        STORE_EXPENSE_TYPE: buildEndpoint('work-orders/expense-types/store'),
        EDIT_EXPENSE_TYPE: buildEndpoint('work-orders/expense-types/:id/edit'),
        SHOW_EXPENSE_TYPE: buildEndpoint('work-orders/expense-types/:id/show'),
        UPDATE_EXPENSE_TYPE: buildEndpoint('work-orders/expense-types/:id/update'),
        DELETE_EXPENSE_TYPE: buildEndpoint('work-orders/expense-types/:id/delete'),
        ACTIVE_EXPENSE_TYPE: buildEndpoint('work-orders/expense-types/:id/active')
    },
    USERS: {
        GET_USERS: buildEndpoint('users/users'),
        GET_USER_LIST: buildEndpoint('users/users/list'),
        GET_USER: buildEndpoint('users/users/:id/get'),
        STORE_USER: buildEndpoint('users/users/store'),
        EDIT_USER: buildEndpoint('users/users/:id/edit'),
        EDIT_PASSWORD_USER: buildEndpoint('users/users/:id/edit-password'),
        CREATE_USER: buildEndpoint('users/users/create'),
        SHOW_USER: buildEndpoint('users/users/:id/show'),
        UPDATE_USER: buildEndpoint('users/users/:id/update'),
        UPDATE_PASSWORD_USER: buildEndpoint('users/users/:id/update-password'),
        DELETE_USER: buildEndpoint('users/users/:id/delete'),
        ACTIVE_USER: buildEndpoint('users/users/:id/active')
    },
    GROUPS: {
        GET_GROUPS: buildEndpoint('auths/groups'),
        STORE_GROUP: buildEndpoint('auths/groups/store'),
        EDIT_GROUP: buildEndpoint('auths/groups/:id/edit'),
        CREATE_GROUP: buildEndpoint('auths/groups/create'),
        SHOW_GROUP: buildEndpoint('auths/groups/:id/show'),
        UPDATE_GROUP: buildEndpoint('auths/groups/:id/update'),
        DELETE_GROUP: buildEndpoint('auths/groups/:id/delete'),
        ACTIVE_GROUP: buildEndpoint('auths/groups/:id/active')
    },
    FUNDS_REQUEST: {
        ALL: buildEndpoint('banks/funds-request'),
        CREATE_FUNDS_REQUEST: buildEndpoint('banks/funds-request/create'),
        STORE_FUNDS_REQUEST: buildEndpoint('banks/funds-request/store'),
        CALCULATE_FUNDS_REQUEST: buildEndpoint('banks/funds-request/:start_date/:end_date/:worker_id/:request_reason/calculate'),
        DELETE_FUNDS_REQUEST: buildEndpoint('banks/funds-request/:id/delete'),
        CHANGE_FUNDS_REQUEST_STATUS: buildEndpoint('banks/funds-request/:id/change-status'),
        EDIT_FUNDS_REQUEST: buildEndpoint('banks/funds-request/:id/edit'),
        UPDATE_FUNDS_REQUEST: buildEndpoint('banks/funds-request/:id/update'),
        CHANGE_FUNDS_REQUEST_STATUSES_ROWS: buildEndpoint('banks/funds-request/change-rows-status'),
        MASIVE_DELETE_FUNDS_REQUEST_ROWS: buildEndpoint('banks/funds-request/massive-rows-delete'),
        CONFIRMED_BY_WORKER: buildEndpoint('banks/funds-request/get-confirmed-by-worker'),
        CONFIRMED_TOTAL_BY_WORKER: buildEndpoint('banks/funds-request/get-confirmed-total-by-worker'),
    },
    NOTIFICATIONS: {
        GET_ALL_BY_USER_RANGE: buildEndpoint('notifications/notifications/by-user-range'),
        GET_NOT_VIEWED: buildEndpoint('notifications/notifications/not-viewed'),
        SET_AS_VIEWED: buildEndpoint('notifications/notifications/:id/viewed'),
        CHECK_PENDING_SURVEY: buildEndpoint('notifications/notifications/check-pending-survey')
    },
    EVENT_TYPES: {
        GET_EVENT_TYPES: buildEndpoint('calendars/event-types'),
        GET_EVENT_TYPE: buildEndpoint('calendars/event-types/:id'),
        CREATE_EVENT_TYPE: buildEndpoint('calendars/event-types/create'),
        STORE_EVENT_TYPE: buildEndpoint('calendars/event-types/store'),
        EDIT_EVENT_TYPE: buildEndpoint('calendars/event-types/:id/edit'),
        SHOW_EVENT_TYPE: buildEndpoint('calendars/event-types/:id/show'),
        UPDATE_EVENT_TYPE: buildEndpoint('calendars/event-types/:id/update'),
        DELETE_EVENT_TYPE: buildEndpoint('calendars/event-types/:id/delete'),
        ACTIVE_EVENT_TYPE: buildEndpoint('calendars/event-types/:id/active')
    },
    PLACES: {
        GET_PLACES: buildEndpoint('places/places'),
        GET_PLACE: buildEndpoint('places/places/:id'),
        CREATE_PLACE: buildEndpoint('places/places/create'),
        STORE_PLACE: buildEndpoint('places/places/store'),
        EDIT_PLACE: buildEndpoint('places/places/:id/edit'),
        SHOW_PLACE: buildEndpoint('places/:id/show'),
        UPDATE_PLACE: buildEndpoint('places/places/:id/update'),
        DELETE_PLACE: buildEndpoint('places/places/:id/delete'),
        ACTIVE_PLACE: buildEndpoint('places/places/:id/active')
    },
    VEHICLES: {
        GET_VEHICLES: buildEndpoint('vehicles/vehicles'),
        STORE_VEHICLE: buildEndpoint('vehicles/vehicles/store'),
        EDIT_VEHICLE: buildEndpoint('vehicles/vehicles/:id/edit'),
        UPDATE_VEHICLE: buildEndpoint('vehicles/vehicles/:id/update'),
        DELETE_VEHICLE: buildEndpoint('vehicles/vehicles/:id/delete'),
        ACTIVE_VEHICLE: buildEndpoint('vehicles/vehicles/:id/active')
    },
    TRANSPORTS: {
        GET_TRANSPORTS: buildEndpoint('vehicles/transports'),
        STORE_TRANSPORT: buildEndpoint('vehicles/transports/store'),
        EDIT_TRANSPORT: buildEndpoint('vehicles/transports/:id/edit'),
        UPDATE_TRANSPORT: buildEndpoint('vehicles/transports/:id/update'),
        DELETE_TRANSPORT: buildEndpoint('vehicles/transports/:id/delete'),
        ACTIVE_TRANSPORT: buildEndpoint('vehicles/transports/:id/active'),
        GET_AVAILABLE_DELIVERIES: buildEndpoint('vehicles/transports/available-deliveries')
    },
    CLIENTS: {
        GET_CLIENTS: buildEndpoint('clients/clients'),
        GET_CLIENT: buildEndpoint('clients/clients/:id'),
        STORE_CLIENT: buildEndpoint('clients/clients/store'),
        EDIT_CLIENT: buildEndpoint('clients/clients/:id/edit'),
        CREATE_CLIENT: buildEndpoint('clients/clients/create'),
        SHOW_CLIENT: buildEndpoint('clients/clients/:id/show'),
        UPDATE_CLIENT: buildEndpoint('clients/clients/:id/update'),
        DELETE_CLIENT: buildEndpoint('clients/clients/:id/delete'),
        ACTIVE_CLIENT: buildEndpoint('clients/clients/:id/active'),
        GET_CLIENTS_BY_SOCIETY: buildEndpoint('clients/:society_id/by-society')
    },
    SOCIETIES: {
        GET_SOCIETIES: buildEndpoint('societies/societies'),
        STORE_SOCIETY: buildEndpoint('societies/societies/store'),
        EDIT_SOCIETY: buildEndpoint('societies/societies/:id/edit'),
        CREATE_SOCIETY: buildEndpoint('societies/societies/create'),
        SHOW_SOCIETY: buildEndpoint('societies/societies/:id/show'),
        UPDATE_SOCIETY: buildEndpoint('societies/societies/:id/update'),
        GET_SOCIETY: buildEndpoint('societies/societies/:id/get'),
        DELETE_SOCIETY: buildEndpoint('societies/societies/:id/delete'),
        ACTIVE_SOCIETY: buildEndpoint('societies/societies/:id/active'),
        GET_SOCIETY_AND_PROVIDERS: buildEndpoint('societies/societies/:id/get-providers'),
    },
    SOCIETY_CLIENTS: {
        GET_SOCIETY_CLIENTS: buildEndpoint('societies/society-clients'),
        GET_SOCIETY_CLIENTS_BY_SOCIETY: buildEndpoint('societies/society-clients/:society_id/by-society'),
        STORE_SOCIETY_CLIENT: buildEndpoint('societies/society-clients/store'),
        EDIT_SOCIETY_CLIENT: buildEndpoint('societies/society-clients/:id/edit'),
        CREATE_SOCIETY_CLIENT: buildEndpoint('societies/society-clients/:society_id/create'),
        SHOW_SOCIETY_CLIENT: buildEndpoint('societies/society-clients/:id/show'),
        UPDATE_SOCIETY_CLIENT: buildEndpoint('societies/society-clients/:id/update'),
        DELETE_SOCIETY_CLIENT: buildEndpoint('societies/society-clients/:id/delete'),
        ACTIVE_SOCIETY_CLIENT: buildEndpoint('societies/society-clients/:id/active'),
    },
    SOCIETY_PROVIDERS: {
        GET_SOCIETY_PROVIDERS: buildEndpoint('societies/society-providers'),
        GET_SOCIETY_PROVIDERS_BY_SOCIETY: buildEndpoint('societies/society-providers/:society_id/by-society'),
        STORE_SOCIETY_PROVIDER: buildEndpoint('societies/society-providers/store'),
        EDIT_SOCIETY_PROVIDER: buildEndpoint('societies/society-providers/:id/edit'),
        CREATE_SOCIETY_PROVIDER: buildEndpoint('societies/society-providers/:society_id/create'),
        SHOW_SOCIETY_PROVIDER: buildEndpoint('societies/society-providers/:id/show'),
        UPDATE_SOCIETY_PROVIDER: buildEndpoint('societies/society-providers/:id/update'),
        DELETE_SOCIETY_PROVIDER: buildEndpoint('societies/society-providers/:id/delete'),
        ACTIVE_SOCIETY_PROVIDER: buildEndpoint('societies/society-providers/:id/active'),
    },
    SOCIETY_DOCUMENTS: {
        HISTORY_BY_SOCIETY_AND_TYPE: buildEndpoint(
            'societies/society-documents/:society_id/:document_id/history'
        ),
        GET_SOCIETY_DOCUMENTS_BY_SOCIETY: buildEndpoint(
            'societies/society-documents/:id/by-society'
        ),
        STORE_SOCIETY_DOCUMENT: buildEndpoint('societies/society-documents/store'),
        EDIT_SOCIETY_DOCUMENT: buildEndpoint(
            'societies/society-documents/:society_id/:document_id/edit'
        ),
        UPDATE_SOCIETY_DOCUMENT: buildEndpoint(
            'societies/society-documents/:society_document_id/update'
        ),
        DELETE_SOCIETY_DOCUMENT: buildEndpoint(
            'societies/society-documents/:society_id/:document_id/delete'
        ),
    },

    SOCIETIES_SIGNATURES: {
        GET_SOCIETY_SIGNATURES: buildEndpoint('societies/societies-signatures'),
        CREATE_SOCIETY_SIGNATURE: buildEndpoint('societies/societies-signatures/create'),
        STORE_SOCIETY_SIGNATURE: buildEndpoint('societies/societies-signatures/store'),
        EDIT_SOCIETY_SIGNATURE: buildEndpoint('societies/societies-signatures/:id/edit'),
        UPDATE_SOCIETY_SGINATURE: buildEndpoint('societies/societies-signatures/:id/update'),
        DELETE_SOCIETY_SIGNATURE: buildEndpoint('societies/societies-signatures/:id/delete')
    },
    CARRIERS: {
        GET_CARRIERS: buildEndpoint('carriers/carriers'),
        GET_CARRIER: buildEndpoint('carriers/carriers/:id/get'),
        CREATE_CARRIER: buildEndpoint('carriers/carriers/create'),
        STORE_CARRIER: buildEndpoint('carriers/carriers/store'),
        EDIT_CARRIER: buildEndpoint('carriers/carriers/:id/edit'),
        SHOW_CARRIER: buildEndpoint('carriers/:id/show'),
        UPDATE_CARRIER: buildEndpoint('carriers/carriers/:id/update'),
        DELETE_CARRIER: buildEndpoint('carriers/carriers/:id/delete'),
        ACTIVE_CARRIER: buildEndpoint('carriers/carriers/:id/active')
    },
    CARRIER_TYPES: {
        GET_CARRIER_TYPES: buildEndpoint('carriers/carrier-types'),
        STORE_CARRIER_TYPE: buildEndpoint('carriers/carrier-types/store'),
        EDIT_CARRIER_TYPE: buildEndpoint('carriers/carrier-types/:id/edit'),
        SHOW_CARRIER_TYPE: buildEndpoint('carriers/carrier-types/:id/show'),
        UPDATE_CARRIER_TYPE: buildEndpoint('carriers/carrier-types/:id/update'),
        DELETE_CARRIER_TYPE: buildEndpoint('carriers/carrier-types/:id/delete'),
        ACTIVE_CARRIER_TYPE: buildEndpoint('carriers/carrier-types/:id/active')
    },
    CARRIER_DOCUMENT: {
        ALL_CARRIER_DOCUMENTS_BY_CARRIER_TYPE: buildEndpoint(
            'carriers/carrier-documents/:carrier_id/:type'
        ),
        STORE_CARRIER_DOCUMENT: buildEndpoint('carriers/carrier-documents/store')
    },
    DOCUMENTS: {
        GET_DOCUMENTS: buildEndpoint('documents/documents'),
        CREATE_DOCUMENT: buildEndpoint('documents/documents/create'),
        STORE_DOCUMENT: buildEndpoint('documents/documents/store'),
        EDIT_DOCUMENT: buildEndpoint('documents/documents/:id/edit'),
        UPDATE_DOCUMENT: buildEndpoint('documents/documents/:id/update'),
        DELETE_DOCUMENT: buildEndpoint('documents/documents/:id/delete'),
        ACTIVE_DOCUMENT: buildEndpoint('documents/documents/:id/active')
    },
    DOCUMENT_SETS: {
        GET_DOCUMENT_SET: buildEndpoint('documents/document-sets'),
        DELETE_DOCUMENT_SET: buildEndpoint('documents/document-set/:id/delete'),
        ACTIVE_DOCUMENT_SET: buildEndpoint('documents/document-set/:id/active'),
        CREATE_DOCUMENT_SET: buildEndpoint('documents/document-set/create'),
        EDIT_DOCUMENT_SET: buildEndpoint('documents/document-set/:id/edit'),
        UPDATE_DOCUMENT_SET: buildEndpoint('documents/document-set/:id/update'),
        STORE_DOCUMENT_SET: buildEndpoint('documents/document-set/store')
    },
    TRUCKS: {
        GET_TRUCKS: buildEndpoint('carriers/trucks'),
        GET_TRUCK: buildEndpoint('carriers/trucks/:id'),
        GET_TRUCKS_LIST: buildEndpoint('carriers/trucks/list'),
        CREATE_TRUCK: buildEndpoint('carriers/trucks/create'),
        STORE_TRUCK: buildEndpoint('carriers/trucks/store'),
        EDIT_TRUCK: buildEndpoint('carriers/trucks/:id/edit'),
        SHOW_TRUCK: buildEndpoint('carriers/trucks/:id/show'),
        UPDATE_TRUCK: buildEndpoint('carriers/trucks/:id/update'),
        DELETE_TRUCK: buildEndpoint('carriers/trucks/:id/delete'),
        ACTIVE_TRUCK: buildEndpoint('carriers/trucks/:id/active')
    },
    PROVIDER_TYPES: {
        GET_PROVIDER_TYPES: buildEndpoint('providers/provider_types'),
        CREATE_PROVIDER_TYPE: buildEndpoint('providers/provider_types/create'),
        STORE_PROVIDER_TYPE: buildEndpoint('providers/provider_types/store'),
        EDIT_PROVIDER_TYPE: buildEndpoint('providers/provider_types/:id/edit'),
        SHOW_PROVIDER_TYPE: buildEndpoint('providers/provider_types/:id/show'),
        UPDATE_PROVIDER_TYPE: buildEndpoint('providers/provider_types/:id/update'),
        DELETE_PROVIDER_TYPE: buildEndpoint('providers/provider_types/:id/delete'),
        ACTIVE_PROVIDER_TYPE: buildEndpoint('providers/provider_types/:id/active')
    },
    TRUCK_DOCUMENT: {
        HISTORY_BY_TRUCK_AND_TYPE: buildEndpoint(
            'carriers/truck-documents/:truck_id/:document_id/history'
        ),
        GET_TRUCK_DOCUMENTS_BY_TRUCK: buildEndpoint('carriers/truck-documents/:id/by-truck'),
        STORE_TRUCK_DOCUMENT: buildEndpoint('carriers/truck-documents/store'),
        GET_BY_SET: buildEndpoint('carriers/truck-documents/:truck_id/get-by-set'),
        EDIT_TRUCK_DOCUMENT: buildEndpoint(
            'carriers/truck-documents/:truck_id/:document_id/edit'
        ),
        UPDATE_TRUCK_DOCUMENT: buildEndpoint(
            'carriers/truck-documents/:truck_document_id/update'
        ),
        DELETE_TRUCK_DOCUMENT: buildEndpoint(
            'carriers/truck-documents/:truck_id/:document_id/delete'
        ),
    },
    HOPPERS: {
        GET_HOPPERS: buildEndpoint('carriers/hoppers'),
        GET_HOPPER: buildEndpoint('carriers/hoppers/:id'),
        GET_HOPPERS_LIST: buildEndpoint('carriers/hoppers/list'),
        CREATE_HOPPER: buildEndpoint('carriers/hoppers/create'),
        STORE_HOPPER: buildEndpoint('carriers/hoppers/store'),
        EDIT_HOPPER: buildEndpoint('carriers/hoppers/:id/edit'),
        SHOW_HOPPER: buildEndpoint('carriers/hoppers/:id/show'),
        UPDATE_HOPPER: buildEndpoint('carriers/hoppers/:id/update'),
        DELETE_HOPPER: buildEndpoint('carriers/hoppers/:id/delete'),
        ACTIVE_HOPPER: buildEndpoint('carriers/hoppers/:id/active')
    },
    HOPPER_DOCUMENT: {
        HISTORY_BY_HOPPER_AND_TYPE: buildEndpoint(
            'carriers/hopper-documents/:hopper_id/:document_id/history'
        ),
        GET_HOPPER_DOCUMENTS_BY_HOPPER: buildEndpoint('carriers/hopper-documents/:id/by-hopper'),
        STORE_HOPPER_DOCUMENT: buildEndpoint('carriers/hopper-documents/store'),
        GET_BY_SET: buildEndpoint('carriers/hopper-documents/:hopper_id/get-by-set'),
        EDIT_HOPPER_DOCUMENT: buildEndpoint(
            'carriers/hopper-documents/:hopper_id/:document_id/edit'
        ),
        UPDATE_HOPPER_DOCUMENT: buildEndpoint(
            'carriers/hopper-documents/:hopper_document_id/update'
        ),
        DELETE_HOPPER_DOCUMENT: buildEndpoint(
            'carriers/hopper-documents/:hopper_id/:document_id/delete'
        ),

    },
    PRODUCTS: {
        GET_PRODUCTS: buildEndpoint('products/products'),
        CREATE_PRODUCT: buildEndpoint('products/products/create'),
        STORE_PRODUCT: buildEndpoint('products/products/store'),
        EDIT_PRODUCT: buildEndpoint('products/products/:id/edit'),
        SHOW_PRODUCT: buildEndpoint('products/products/:id/show'),
        UPDATE_PRODUCT: buildEndpoint('products/products/:id/update'),
        DELETE_PRODUCT: buildEndpoint('products/products/:id/delete'),
        ACTIVE_PRODUCT: buildEndpoint('products/products/:id/active'),
        GET_PRODUCT_WITH_PURCHASE_ORDER: buildEndpoint('products/products/:id/:purchase_order_id/with-purchase-order'),
        GET_PRODUCT_RECIPE: buildEndpoint('products/products/:id/recipe'),
        STORE_PRODUCT_RECIPE_LINE: buildEndpoint('products/products/:id/recipe/store'),
        DELETE_PRODUCT_RECIPE_LINE: buildEndpoint('products/products/recipe/:id/delete')
    },
    UNITS: {
        GET_UNITS: buildEndpoint('products/units'),
        STORE_UNIT: buildEndpoint('products/units/store'),
        EDIT_UNIT: buildEndpoint('products/units/:id/edit'),
        SHOW_UNIT: buildEndpoint('products/units/:id/show'),
        UPDATE_UNIT: buildEndpoint('products/units/:id/update'),
        DELETE_UNIT: buildEndpoint('products/units/:id/delete'),
        ACTIVE_UNIT: buildEndpoint('products/units/:id/active')
    },
    UNIT_EQUIVALENCE: {
        GET_UNIT_EQUIVALENCES: buildEndpoint('products/unit-equivalences'),
        CREATE_UNIT_EQUIVALENCE: buildEndpoint('products/unit-equivalences/create'),
        STORE_UNIT_EQUIVALENCE: buildEndpoint('products/unit-equivalences/store'),
        EDIT_UNIT_EQUIVALENCE: buildEndpoint('products/unit-equivalences/:id/edit'),
        UPDATE_UNIT_EQUIVALENCE: buildEndpoint('products/unit-equivalences/:id/update'),
        DELETE_UNIT_EQUIVALENCE: buildEndpoint('products/unit-equivalences/:id/delete'),
        ACTIVE_UNIT_EQUIVALENCE: buildEndpoint('products/unit-equivalences/:id/active'),
        CALCULATE_UNIT_EQUIVALENCE: buildEndpoint('products/unit-equivalences/calculate')
    },
    UNIT_CONVERSIONS: {
        GET_UNIT_CONVERSIONS: buildEndpoint('unit-conversions/unit-conversions'),
        STORE_UNIT_CONVERSION: buildEndpoint('unit-conversions/unit-conversions/store'),
        CREATE_UNIT_CONVERSION: buildEndpoint('unit-conversions/unit-conversions/create'),
        EDIT_UNIT_CONVERSION: buildEndpoint('unit-conversions/unit-conversions/:id/edit'),
        SHOW_UNIT_CONVERSION: buildEndpoint('unit-conversions/unit-conversions/:id/show'),
        UPDATE_UNIT_CONVERSION: buildEndpoint('unit-conversions/unit-conversions/:id/update'),
        DELETE_UNIT_CONVERSION: buildEndpoint('unit-conversions/unit-conversions/:id/delete'),
    },
    CURRENCIES: {
        GET_CURRENCIES: buildEndpoint('currencies/currencies'),
        CREATE_CURRENCY: buildEndpoint('currencies/currencies/create'),
        STORE_CURRENCY: buildEndpoint('currencies/currencies/store'),
        EDIT_CURRENCY: buildEndpoint('currencies/currencies/:id/edit'),
        SHOW_CURRENCY: buildEndpoint('currencies/currencies/:id/show'),
        UPDATE_CURRENCY: buildEndpoint('currencies/currencies/:id/update'),
        DELETE_CURRENCY: buildEndpoint('currencies/currencies/:id/delete'),
        ACTIVE_CURRENCY: buildEndpoint('currencies/currencies/:id/active')
    },
    FOREIGN_EXCHANGE: {
        GET_FOREIGN_EXCHANGE: buildEndpoint('currencies/foreign-exchanges')
    },
    SIDEBAR_ITEMS: {
        GET_SIDEBAR_ITEMS: buildEndpoint('sidebaritems/sidebaritems'),
        SEARCH_SIDEBAR_ITEMS: buildEndpoint('sidebaritems/sidebaritems/search')


    },
    PROVIDERS: {
        GET_PROVIDERS: buildEndpoint('providers/providers'),
        //GET_PROVIDER: buildEndpoint('providers/providers/:id'),
        GET_PROVIDER_CONTACT: buildEndpoint('providers/providers/:id/get-contact'),
        CREATE_PROVIDER: buildEndpoint('providers/providers/create'),
        STORE_PROVIDER: buildEndpoint('providers/providers/store'),
        EDIT_PROVIDER: buildEndpoint('providers/providers/:id/edit'),
        SHOW_PROVIDER: buildEndpoint('providers/:id/show'),
        UPDATE_PROVIDER: buildEndpoint('providers/providers/:id/update'),
        DELETE_PROVIDER: buildEndpoint('providers/providers/:id/delete'),
        ACTIVE_PROVIDER: buildEndpoint('providers/providers/:id/active'),
        GET_PROVIDER: buildEndpoint('providers/providers/:id/get'),
        GET_DAILY_CARRIER_PROVIDERS_ON_DISPATCH_PROGRAM: buildEndpoint('providers/providers/:dispatch_program_id/providers-on-dp'),
        GET_PROVIDERS_BY_SOCIETY: buildEndpoint('providers/:society_id/by-society')
    },
    WORK_ORDERS: {
        GET_WORK_ORDERS: buildEndpoint('work-orders/work-orders'),
        STORE_WORK_ORDERS: buildEndpoint('work-orders/work-orders/store'),
        CREATE_WORK_ORDERS: buildEndpoint('work-orders/work-orders/create'),
        DELETE_WORK_ORDER: buildEndpoint('work-orders/work-orders/:id/delete'),
        EDIT_WORK_ORDER: buildEndpoint('work-orders/work-orders/:id/edit'),
        SHOW_WORK_ORDER: buildEndpoint('work-orders/work-orders/:id/show'),
        UPDATE_WORK_ORDER: buildEndpoint('work-orders/work-orders/:id/update'),
        HAS_ALL_FINISHED_STATUSES_TRANSPORT_ORDER: buildEndpoint(
            'work-orders/work-orders/:id/:work_order_status/has-finished'
        ),
        CHANGE_STATUS_TRANSPORT_ORDER: buildEndpoint('work-orders/work-orders/:id/change-status')
    },
    TRANSPORT_ORDERS: {
        GET_TRANSPORT_ORDER: buildEndpoint('work-orders/transport-orders'),
        GET_TRANSPORT_ORDER_BY_CARRIER_CHART: buildEndpoint(
            'work-orders/transport-orders/all-transport-order-by-carrier-chart'
        ),
        GET_TRANSPORT_ORDER_BY_WORK_ORDER: buildEndpoint(
            'work-orders/transport-orders/:work_order_id/by-work-order'
        ),
        GET_TRANSPORT_ORDERS_TO_DISPATCH_PROGRAM: buildEndpoint(
            'work-orders/transport-orders/:dispatch_program_id/by-dispatch-program'
        ),
        GET_EXCEL_TRANSPORT_ORDERS_BY_WORK_ORDER: buildEndpoint(
            'work-orders/transport-orders/:work_order_id/by-work-order/excel'
        ),
        STORE_TRANSPORT_ORDER: buildEndpoint('work-orders/transport-orders/store'),
        MULTISTORE_TRANSPORT_ORDER: buildEndpoint('work-orders/transport-orders/multistore'),
        CREATE_TRANSPORT_ORDER: buildEndpoint('work-orders/transport-orders/:work_order_id/create'),
        DELETE_TRANSPORT_ORDER: buildEndpoint('work-orders/transport-orders/:id/delete'),
        EDIT_TRANSPORT_ORDER: buildEndpoint('work-orders/transport-orders/:id/edit'),
        SHOW_TRANSPORT_ORDER: buildEndpoint('work-orders/transport-orders/:id/show'),
        UPDATE_TRANSPORT_ORDER: buildEndpoint('work-orders/transport-orders/:id/update'),
        VALIDATE_STATUS_CHANGE_TRANSPORT_ORDER: buildEndpoint(
            'work-orders/transport-orders/:id/:transport_order_status/validate-status'
        ),
        CHANGE_STATUS_TRANSPORT_ORDER: buildEndpoint(
            'work-orders/transport-orders/:id/change-status'
        ),
        UNLOCK_STATUS_TRANSPORT_ORDER: buildEndpoint(
            'work-orders/transport-orders/:id/unlock-status'
        ),
        GET_EXCEL_TRANSPORT_ORDERS: buildEndpoint('work-orders/transport-orders/excel'),
        GET_TRANSPORT_ORDER_BY_ID_WITH_GUIDE: buildEndpoint(
            'work-orders/transport-orders/:id/get-transport-order-with-guide'
        ),
        GET_TRANSPORT_ORDERS_COMMISSIONS_BY_WORKER: buildEndpoint(
            'work-orders/transport-orders/commissions-by-worker'
        ),
        GET_TRANSPORT_ORDERS_COMMISSIONS_SUM_BY_WORKER: buildEndpoint(
            'work-orders/transport-orders/commissions-sum-by-worker'
        ),
        CREATE_MASSIVE_COMMISSIONS_CHANGE: buildEndpoint(
            'work-orders/transport-orders/create-massive-commission-change'
        ),
        MASSIVE_COMMISSIONS_CHANGE: buildEndpoint(
            'work-orders/transport-orders/massive-commission-change'
        ),
        GET_TRANSPORT_ORDER_POSITION_INFO: buildEndpoint(
            'work-orders/transport-orders/position-info'
        ),
    },
    TRANSPORT_ORDER_STATUS_HISTORIES: {
        GET_TRANSPORT_ORDER_STATUS_HISTORIES_BY_TRANSPORT_ORDER: buildEndpoint(
            'work-orders/transport-order-status-histories/:transport_order_id/by-transport-order'
        )
    },
    MONTHLY_RECONCILIATIONS: {
        GET_MONTHLY_RECONCILIATIONS: buildEndpoint('work-orders/monthly-reconciliations'),
        GET_EXCEL_MONTHLY_RECONCILIATIONS: buildEndpoint(
            'work-orders/monthly-reconciliations/excel'
        )
    },
    MONTHLY_CLOSURES: {
        STORE_MONTHLY_CLOSURES: buildEndpoint('monthly-closures/monthly-closures/store'),
        ALL_MONTHLY_CLOSURES: buildEndpoint('monthly-closures/monthly-closures'),
        EDIT_MONTHLY_CLOSURES: buildEndpoint('monthly-closures/monthly-closures/:id/edit')
    },
    MONTHLY_CLOSURE_DETAILS: {
        ALL_MONTHLY_CLOSURE_DETAILS_BY_CLOSURE: buildEndpoint('monthly-closures/monthly-closure-details/:monthly_closure_id/by-monthly-closure'),
        CREATE_MONTHLY_CLOSURE_DETAIL: buildEndpoint('monthly-closures/monthly-closure-details/:monthly_closure_id/create'),
        STORE_MONTHLY_CLOSURE_DETAIL: buildEndpoint('monthly-closures/monthly-closure-details/store'),
        CAN_CHANGE_MONTHLY_CLOSURE_DETAIL_STATUS: buildEndpoint('monthly-closures/monthly-closure-details/:id/:status/can-change-status'),
        CHANGE_MONTHLY_CLOSURE_DETAIL_STATUS: buildEndpoint('monthly-closures/monthly-closure-details/:id/change-status'),
        CLOSE_MONTHLY_CLOSURE_DETAIL_STATUS: buildEndpoint('monthly-closures/monthly-closure-details/:id/close-status'),
        ANNULLED_MONTHLY_CLOSURE_DETAIL_STATUS: buildEndpoint('monthly-closures/monthly-closure-details/:id/annulled-status'),
    },
    MONTHLY_CLOSURE_DETAIL_HISTORIES: {
        ALL_MONTHLY_CLOSURE_DETAIL_HISTORIES_BY_MONTHLY_CLOSURE_DETAIL: 
            buildEndpoint('monthly-closures/monthly-closure-detail-histories/:monthly_closure_detail_id/by-monthly-closure-detail')
    },
    WORK_ORDER_STATUS_HISTORIES: {
        GET_WORK_ORDER_STATUS_HISTORIES_BY_WORK_ORDER: buildEndpoint(
            'work-orders/work-order-status-histories/:transport_work_id/by-work-order'
        )
    },
    EXPENSES: {
        GET_EXPENSES_BY_TRANSPORT_ORDER: buildEndpoint(
            'work-orders/expenses/:transport_order_id/by-transport-order'
        ),
        GET_EXPENSES: buildEndpoint('work-orders/expenses'),
        GET_EXPENSES_TOTAL_AMOUNT: buildEndpoint('work-orders/expenses/total-amount'),
        GET_NON_TOLL_EXPENSES: buildEndpoint('work-orders/expenses/non-toll'),
        GET_EXCEL_EXPENSES: buildEndpoint('work-orders/expenses/excel'),
        DOCUMENT_EXPENSE: buildEndpoint('work-orders/expenses/:id/get-document'),
        DOCUMENT_EXPENSE_ON_TRANSPORT_ORDER: buildEndpoint(
            'work-orders/expenses/:transport_order_id/:id/get-document-to'
        ),
        DOCUMENT_EXPENSE_ON_CALENDAR: buildEndpoint('work-orders/expenses/:id/get-document-to'),
        CREATE_EXPENSE: buildEndpoint('work-orders/expenses/:transport_order_id/create'),
        CREATE_CALENDAR_EXPENSE: buildEndpoint('work-orders/expenses/create'),
        STORE_EXPENSE: buildEndpoint('work-orders/expenses/:transport_order_id/store'),
        STORE_EXPENSE_BY_EVENT: buildEndpoint('work-orders/expenses/:event_id/store_by_event'),
        EDIT_EXPENSE: buildEndpoint('work-orders/expenses/:transport_order_id/:id/edit'),
        UPDATE_EXPENSE: buildEndpoint('work-orders/expenses/:transport_order_id/:id/update'),
        EDIT_CALENDAR_EXPENSE: buildEndpoint('work-orders/expenses/:id/edit'),
        UPDATE_CALENDAR_EXPENSE: buildEndpoint('work-orders/expenses/:id/update'),
        DELETE_EXPENSE: buildEndpoint('work-orders/expenses/:transport_order_id/:id/delete'),
        DELETE_CALENDAR_EXPENSE: buildEndpoint('work-orders/expenses/:id/delete'),
        GET_EXPENSE_ON_CHECKING_ACCOUNT_CREATE: buildEndpoint('work-orders/expenses/:id/get'),
        GET_EXPENSE_ON_CHECKING_ACCOUNT_EDIT: buildEndpoint(
            'work-orders/expenses/:id/:checking_account_id/get'
        ),
        GET_EXPENSES_BY_DATES: buildEndpoint('work-orders/expenses/get-by-dates'),
        GET_EXPENSES_BY_EVENT_ID: buildEndpoint('work-orders/expenses/get-by-event-id/:event_id'),
        SHOW_EXPENSE: buildEndpoint('work-orders/expenses/:transport_order_id/:id/show'),
        APPROVED_EXPENSE: buildEndpoint('work-orders/expenses/:transport_order_id/:id/approved'),
        CANCEL_APPROVED_EXPENSE: buildEndpoint('work-orders/expenses/:id/cancel-approved'),
        APPROVED_CALENDAR_EXPENSE: buildEndpoint('work-orders/expenses/:id/:worker_id/approved-calendar'),
        CHANGE_APPROVE_ROWS_FROM_EXPENSE: buildEndpoint('work-orders/expenses/change-rows-approve')
    },
    EXPENSE_HISTORIES: {
        GET_EXPENSE_HISTORIES_BY_EXPENSE: buildEndpoint(
            'work-orders/expense-histories/:expense_id/by-expense'
        ),
        EDIT_EXPENSE_HISTORY: buildEndpoint('work-orders/expense-histories/:id/edit'),
        UPDATE_EXPENSE_HISTORY: buildEndpoint('work-orders/expense-histories/:id/update')
    },
    TOLL_EXPENSES: {
        GET_TOLL_EXPENSES_BY_TRANSPORT_ORDER: buildEndpoint(
            'work-orders/toll-expenses/:transport_order_id/by-transport-order'
        ),
        GET_TOLL_EXPENSES: buildEndpoint('work-orders/expenses'),
        DOCUMENT_TOLL_EXPENSE_ON_TRANSPORT_ORDER: buildEndpoint(
            'work-orders/toll-expenses/:transport_order_id/:id/get-document-to'
        ),
        CREATE_TOLL_EXPENSE: buildEndpoint('work-orders/toll-expenses/:transport_order_id/create'),
        STORE_TOLL_EXPENSE: buildEndpoint('work-orders/toll-expenses/:transport_order_id/store'),
        EDIT_TOLL_EXPENSE: buildEndpoint('work-orders/toll-expenses/:transport_order_id/:id/edit'),
        UPDATE_TOLL_EXPENSE: buildEndpoint(
            'work-orders/toll-expenses/:transport_order_id/:id/update'
        ),
        DELETE_TOLL_EXPENSE: buildEndpoint(
            'work-orders/toll-expenses/:transport_order_id/:id/delete'
        ),
        SHOW_TOLL_EXPENSE: buildEndpoint('work-orders/toll-expenses/:transport_order_id/:id/show'),
        APPROVED_TOLL_EXPENSE: buildEndpoint(
            'work-orders/toll-expenses/:transport_order_id/:id/approved'
        ),
        CANCEL_APPROVED_TOLL_EXPENSE: buildEndpoint(
            'work-orders/toll-expenses/:id/cancel-approved'
        ),
        SHOW_FILE_TOLL_EXPENSE: buildEndpoint(
            'work-orders/toll-expenses/:transport_order_id/:id/show-file'
        ),
        TOLL_EXPENSE_SUM_AMOUNT: buildEndpoint(
            'work-orders/toll-expenses/sum-amount'
        ),
        ALL_TOLL_EXPENSES: buildEndpoint(
            'work-orders/toll-expenses'
        ),
    },
    TOLL_EXPENSE_HISTORIES: {
        GET_TOLL_EXPENSE_HISTORIES_BY_TOLL_EXPENSE: buildEndpoint(
            'work-orders/toll-expense-histories/:toll_expense_id/by-toll-expense'
        ),
        EDIT_TOLL_EXPENSE_HISTORY: buildEndpoint('work-orders/toll-expense-histories/:id/edit'),
        UPDATE_TOLL_EXPENSE_HISTORY: buildEndpoint('work-orders/toll-expense-histories/:id/update')
    },
    LOAD_TICKETS: {
        GET_LOAD_TICKET_BY_TRANSPORT_ORDER: buildEndpoint(
            'work-orders/load-tickets/:transport_order_id/by-transport-order'
        ),
        GET_LOAD_TICKETS: buildEndpoint('work-orders/load-tickets'),
        CREATE_LOAD_TICKET: buildEndpoint('work-orders/load-tickets/:transport_order_id/create'),
        STORE_LOAD_TICKET: buildEndpoint('work-orders/load-tickets/:transport_order_id/store'),
        EDIT_LOAD_TICKET: buildEndpoint('work-orders/load-tickets/:transport_order_id/:id/edit'),
        UPDATE_LOAD_TICKET: buildEndpoint(
            'work-orders/load-tickets/:transport_order_id/:id/update'
        ),
        DELETE_LOAD_TICKET: buildEndpoint(
            'work-orders/load-tickets/:transport_order_id/:id/delete'
        ),
        SHOW_LOAD_TICKET: buildEndpoint('work-orders/load-tickets/:transport_order_id/:id/show'),
        DOCUMENT_LOAD_TICKET: buildEndpoint('work-orders/load-tickets/:id/get-document'),
        DOCUMENT_LOAD_TICKET_ON_TRANSPORT_ORDER: buildEndpoint(
            'work-orders/load-tickets/:transport_order_id/:id/get-document-to'
        ),
        APPROVED_LOAD_TICKET: buildEndpoint(
            'work-orders/load-tickets/:transport_order_id/:id/approved'
        ),
        CANCEL_APPROVED_LOAD_TICKET: buildEndpoint(
            'work-orders/load-tickets/:id/cancel-approved'
        )
    },
    LOAD_TICKET_HISTORIES: {
        GET_LOAD_TICKET_HISTORIES_BY_LOAD_TICKETE: buildEndpoint(
            'work-orders/load-ticket-histories/:load_ticket_id/by-load-ticket'
        ),
        EDIT_LOAD_TICKET_HISTORY: buildEndpoint('work-orders/load-ticket-histories/:id/edit'),
        UPDATE_LOAD_TICKET_HISTORY: buildEndpoint('work-orders/load-ticket-histories/:id/update')
    },
    GUIDES: {
        GET_GUIDES_BY_TRANSPORT_ORDER: buildEndpoint(
            'work-orders/guides/:transport_order_id/by-transport-order'
        ),
        GET_GUIDES: buildEndpoint('work-orders/guides'),
        CREATE_GUIDE: buildEndpoint('work-orders/guides/:transport_order_id/create'),
        STORE_GUIDE: buildEndpoint('work-orders/guides/:transport_order_id/store'),
        EDIT_GUIDE: buildEndpoint('work-orders/guides/:transport_order_id/:id/edit'),
        UPDATE_GUIDE: buildEndpoint('work-orders/guides/:transport_order_id/:id/update'),
        DELETE_GUIDE: buildEndpoint('work-orders/guides/:transport_order_id/:id/delete'),
        SHOW_GUIDE: buildEndpoint('work-orders/guides/:transport_order_id/:id/show'),
        DOCUMENT_GUIDE: buildEndpoint('work-orders/guides/:id/get-document'),
        DOCUMENT_GUIDE_ON_TRANSPORT_ORDER: buildEndpoint(
            'work-orders/guides/:transport_order_id/:id/get-document-to'
        ),
        APPROVED_GUIDE: buildEndpoint('work-orders/guides/:transport_order_id/:id/approved'),
        CANCEL_APPROVED_GUIDE: buildEndpoint('work-orders/guides/:id/cancel-approved')
    },
    GUIDE_HISTORIES: {
        GET_GUIDE_HISTORIES_BY_GUIDE: buildEndpoint(
            'work-orders/guide-histories/:guide_id/by-guide'
        ),
        EDIT_GUIDE_HISTORY: buildEndpoint('work-orders/guide-histories/:id/edit'),
        UPDATE_GUIDE_HISTORY: buildEndpoint('work-orders/guide-histories/:id/update')
    },

    INCIDENTS: {
        GET_INCIDENTS: buildEndpoint('work-orders/incidents/:transport_order_id/by-transport-order'),
        STORE_INCIDENT: buildEndpoint('work-orders/incidents/store'),
        CREATE_INCIDENT: buildEndpoint('work-orders/incidents/create'),
        DELETE_INCIDENT: buildEndpoint('work-orders/incidents/:id/delete'),
        EDIT_INCIDENT: buildEndpoint('work-orders/incidents/:id/edit'),
        SHOW_INCIDENT: buildEndpoint('work-orders/incidents/:id/show'),
        UPDATE_INCIDENT: buildEndpoint('work-orders/incidents/:id/update'),
        OPEN_INCIDENT: buildEndpoint('work-orders/incidents/:id/open'), 
        CLOSE_INCIDENT: buildEndpoint('work-orders/incidents/:id/close'),
        ANNUL_INCIDENT: buildEndpoint('work-orders/incidents/:id/annul'),
        GET_EVIDENCE_INCIDENT: buildEndpoint('work-orders/incidents/:id/get-evidence'),

    },

    INCIDENT_REASONS: {
        GET_INCIDENT_REASONS: buildEndpoint('incident-reasons/incident-reasons'),
        STORE_INCIDENT_REASON: buildEndpoint('incident-reasons/incident-reasons/store'),
        CREATE_INCIDENT_REASON: buildEndpoint('incident-reasons/incident-reasons/create'),
        DELETE_INCIDENT_REASON: buildEndpoint('incident-reasons/incident-reasons/:id/delete'),
        EDIT_INCIDENT_REASON: buildEndpoint('incident-reasons/incident-reasons/:id/edit'),
        UPDATE_INCIDENT_REASON: buildEndpoint('incident-reasons/incident-reasons/:id/update'),
        ACTIVE_INCIDENT_REASON: buildEndpoint('incident-reasons/incident-reasons/:id/active')
    },

    ROUTE_SEGMENTS: {
        GET_ROUTE_SEGMENTS: buildEndpoint('route-segments/route-segments'),
        CREATE_ROUTE_SEGMENTS: buildEndpoint('route-segments/route-segments/create'),
        STORE_ROUTE_SEGMENT: buildEndpoint('route-segments/route-segments/store'),
        EDIT_ROUTE_SEGMENT: buildEndpoint('route-segments/route-segments/:id/edit'),
        UPDATE_ROUTE_SEGMENT: buildEndpoint('route-segments/route-segments/:id/update'),
        SHOW_RS_TO_QUOTE_ROUTE_SEGMENT: buildEndpoint(
            'route-segments/route-segments/:quote_route_segment_id/:id/show-route-segment'
        ),
        SHOW_RS_TO_TRANSPORTATION_QUOTE_DETAIL: buildEndpoint(
            'route-segments/route-segments/:transportation_quote_detail_id/:id/show-route-segment-tqd'
        ),
        SHOW_RS_TO_TRANSPORTATION_ORDER_ITEM: buildEndpoint(
            'route-segments/route-segments/:transportation_order_item_id/:id/show-route-segment-toi'
        ),
        DELETE_ROUTE_SEGMENT: buildEndpoint('route-segments/route-segments/:id/delete'),

        GET_QUOTE_ROUTE_SEGMENTS: buildEndpoint('route-segments/quote-route-segments/:id/all'),
        CREATE_QUOTE_ROUTE_SEGMENT: buildEndpoint('route-segments/quote-route-segments/create'),
        STORE_QUOTE_ROUTE_SEGMENT: buildEndpoint('route-segments/quote-route-segments/store'),
        EDIT_QUOTE_ROUTE_SEGMENT: buildEndpoint('route-segments/quote-route-segments/:id/edit'),
        UPDATE_QUOTE_ROUTE_SEGMENT: buildEndpoint('route-segments/quote-route-segments/:id/update'),
        DELETE_QUOTE_ROUTE_SEGMENT: buildEndpoint('route-segments/quote-route-segments/:id/delete'),
        SHOW_QUOTE_ROUTE_SEGMENT: buildEndpoint('route-segments/quote-route-segments/:id/show'),
        GET_QUOTE_ROUTE_SEGMENT: buildEndpoint('route-segments/quote-route-segments/:id/get'),
        INVERSE_ROUTE_SEGMENTS: buildEndpoint('route-segments/route-segments/:id/get-inverse')
    },
    TOLLS: {
        GET_TOLLS: buildEndpoint('tolls/tolls'),
        GET_TOLL: buildEndpoint('tolls/tolls/:id'),
        CREATE_TOLL: buildEndpoint('tolls/tolls/create'),
        STORE_TOLL: buildEndpoint('tolls/tolls/store'),
        EDIT_TOLL: buildEndpoint('tolls/tolls/:id/edit'),
        SHOW_TOLL: buildEndpoint('tolls/tolls/:id/show'),
        UPDATE_TOLL: buildEndpoint('tolls/tolls/:id/update'),
        DELETE_TOLL: buildEndpoint('tolls/tolls/:id/delete')
    },
    TOLL_RATES: {
        GET_TOLL_RATES_BY_TOLL: buildEndpoint('tolls/toll-rates/:toll_id/by-toll'),
        STORE_TOLL_RATE: buildEndpoint('tolls/toll-rates/store'),
        CREATE_TOLL_RATE: buildEndpoint('tolls/toll-rates/create'),
        DELETE_TOLL_RATE: buildEndpoint('tolls/toll-rates/:id/delete'),
        EDIT_TOLL_RATE: buildEndpoint('tolls/toll-rates/:id/edit'),
        SHOW_TOLL_RATE: buildEndpoint('tolls/toll-rates/:id/show'),
        UPDATE_TOLL_RATE: buildEndpoint('tolls/toll-rates/:id/update'),
        GET_TOLL_RATE_BY_TOLL: buildEndpoint(
            'tolls/toll-rates/:transport_order_id/:toll_id/:toll_expense_id/get-rate'
        )
    },
    AFPS: {
        GET_AFPS: buildEndpoint('afps/afps'),
        STORE_AFP: buildEndpoint('afps/afps/store'),
        EDIT_AFP: buildEndpoint('afps/afps/:id/edit'),
        SHOW_AFP: buildEndpoint('afps/afps/:id/show'),
        UPDATE_AFP: buildEndpoint('afps/afps/:id/update'),
        DELETE_AFP: buildEndpoint('afps/afps/:id/delete'),
        ACTIVE_AFP: buildEndpoint('afps/afps/:id/active')
    },
    AFP_RATES: {
        GET_AFP_RATES_BY_AFP: buildEndpoint('afps/afps-rates/:afp_id/by-afp'),
        STORE_AFP_RATE: buildEndpoint('afps/afps-rates/store'),
        CREATE_AFP_RATE: buildEndpoint('afps/afps-rates/create'),
        DELETE_AFP_RATE: buildEndpoint('afps/afps-rates/:id/delete'),
        EDIT_AFP_RATE: buildEndpoint('afps/afps-rates/:id/edit'),
        SHOW_AFP_RATE: buildEndpoint('afps/afps-rates/:id/show'),
        UPDATE_AFP_RATE: buildEndpoint('afps/afps-rates/:id/update'),
        ACTIVE_AFP_RATE: buildEndpoint('afps/afps-rates/:id/active')
    },
    BANKS: {
        GET_BANKS: buildEndpoint('banks/banks'),
        STORE_BANK: buildEndpoint('banks/banks/store'),
        EDIT_BANK: buildEndpoint('banks/banks/:id/edit'),
        SHOW_BANK: buildEndpoint('banks/banks/:id/show'),
        UPDATE_BANK: buildEndpoint('banks/banks/:id/update'),
        DELETE_BANK: buildEndpoint('banks/banks/:id/delete'),
        ACTIVE_BANK: buildEndpoint('banks/banks/:id/active')
    },
    BANK_ACCOUNT: {
        BANK_ACCOUNT_BY_REASON: buildEndpoint('banks/bank-account/by-reason/:reason_id/:worker_id'),
        BANK_ACCOUNT_BY_WORKER: buildEndpoint('banks/bank-account/by-worker/:worker_id'),
        DELETE_BANK_ACCOUNT: buildEndpoint('banks/bank-account/:id/delete'),
        CREATE_BANK_ACCOUNT_BY_WORKER: buildEndpoint('banks/bank-account/:worker_id/create'),
        STORE_BANK_ACCOUNT: buildEndpoint('banks/bank-account/store'),
        UPDATE_BANK_ACCOUNT: buildEndpoint('banks/bank-account/:bank_account/update'),
        EDIT_BANK_ACCOUNT: buildEndpoint('banks/bank-account/:bank_account/edit'),
    },
    TRANSFER_REASONS: {
        GET_TRANSFER_REASONS: buildEndpoint('banks/transfer-reasons'),
        STORE_TRANSFER_REASON: buildEndpoint('banks/transfer-reasons/store'),
        EDIT_TRANSFER_REASON: buildEndpoint('banks/transfer-reasons/:id/edit'),
        SHOW_TRANSFER_REASON: buildEndpoint('banks/transfer-reasons/:id/show'),
        UPDATE_TRANSFER_REASON: buildEndpoint('banks/transfer-reasons/:id/update'),
        DELETE_TRANSFER_REASON: buildEndpoint('banks/transfer-reasons/:id/delete'),
        ACTIVE_TRANSFER_REASON: buildEndpoint('banks/transfer-reasons/:id/active')
    },
    BANK_ACCOUNT_REASONS: {
        GET_BANK_ACCOUNT_REASONS: buildEndpoint('banks/bank-account-reasons'),
        STORE_BANK_ACCOUNT_REASON: buildEndpoint('banks/bank-account-reasons/store'),
        EDIT_BANK_ACCOUNT_REASON: buildEndpoint('banks/bank-account-reasons/:id/edit'),
        UPDATE_BANK_ACCOUNT_REASON: buildEndpoint('banks/bank-account-reasons/:id/update'),
        DELETE_BANK_ACCOUNT_REASON: buildEndpoint('banks/bank-account-reasons/:id/delete'),
        ACTIVE_BANK_ACCOUNT_REASON: buildEndpoint('banks/bank-account-reasons/:id/active')
    },
    BANK_ACCOUNT_TYPES: {
        GET_BANK_ACCOUNT_TYPES: buildEndpoint('banks/bank-account-types'),
        STORE_BANK_ACCOUNT_TYPE: buildEndpoint('banks/bank-account-types/store'),
        EDIT_BANK_ACCOUNT_TYPE: buildEndpoint('banks/bank-account-types/:id/edit'),
        SHOW_BANK_ACCOUNT_TYPE: buildEndpoint('banks/bank-account-types/:id/show'),
        UPDATE_BANK_ACCOUNT_TYPE: buildEndpoint('banks/bank-account-types/:id/update'),
        DELETE_BANK_ACCOUNT_TYPE: buildEndpoint('banks/bank-account-types/:id/delete'),
        ACTIVE_BANK_ACCOUNT_TYPE: buildEndpoint('banks/bank-account-types/:id/active')
    },

    CHECKING_ACCOUNTS: {
        GET_CHECKING_ACCOUNTS: buildEndpoint('banks/checking-accounts'),
        CREATE_CHECKING_ACCOUNT: buildEndpoint('banks/checking-accounts/create'),
        STORE_CHECKING_ACCOUNT: buildEndpoint('banks/checking-accounts/store'),
        EDIT_CHECKING_ACCOUNT: buildEndpoint('banks/checking-accounts/:id/edit'),
        SHOW_CHECKING_ACCOUNT: buildEndpoint('banks/checking-accounts/:id/show'),
        UPDATE_CHECKING_ACCOUNT: buildEndpoint('banks/checking-accounts/:id/update'),
        DELETE_CHECKING_ACCOUNT: buildEndpoint('banks/checking-accounts/:id/delete'),
        ACTIVE_CHECKING_ACCOUNT: buildEndpoint('banks/checking-accounts/:id/active'),
        APPROVED_CHECKING_ACCOUNT: buildEndpoint('banks/checking-accounts/:id/approved'),
        REJECTED_CHECKING_ACCOUNT: buildEndpoint('banks/checking-accounts/:id/rejected'),
        GET_CHECKING_ACCOUNT_HISTORY: buildEndpoint('banks/checking-accounts/:id/history'),
        GET_CHECKING_ACCOUNT_TOTAL_BY_WORKER: buildEndpoint('banks/checking-accounts/get-total-by-worker'),
        GET_CHECKING_ACCOUNT_BY_WORKER: buildEndpoint('banks/checking-accounts/all-by-worker'),

    },

    CLASIFICATIONS: {
        GET_CLASIFICATIONS: buildEndpoint('accounts/clasifications'),
        CREATE_CLASIFICATIONS: buildEndpoint('accounts/clasifications/create'),
        STORE_CLASIFICATION: buildEndpoint('accounts/clasifications/store'),
        EDIT_CLASIFICATION: buildEndpoint('accounts/clasifications/:id/edit'),
        UPDATE_CLASIFICATION: buildEndpoint('accounts/clasifications/:id/update'),
        DELETE_CLASIFICATION: buildEndpoint('accounts/clasifications/:id/delete'),
        ACTIVE_CLASIFICATION: buildEndpoint('accounts/clasifications/:id/active')
    },
    INTERNAL_SETTLEMENTS: {
        GET_INTERNAL_SETTLEMENTS: buildEndpoint('banks/internal-settlements'),
        GET_EXCEL_INTERNAL_SETTLEMENTS: buildEndpoint('banks/internal-settlements/excel'),
        SHOW_INTERNAL_SETTLEMENT: buildEndpoint('banks/internal-settlements/:id/show'),
        SHOW_DEBIT_INTERNAL_SETTLEMENT: buildEndpoint('banks/internal-settlements/:id/show-debit')

    },
    PROVISIONS: {
        GET_PROVISIONS: buildEndpoint('provisions/provisions'),
        STORE_PROVISION: buildEndpoint('provisions/provisions/store'),
        EDIT_PROVISION: buildEndpoint('provisions/provisions/:id/edit'),
        SHOW_PROVISION: buildEndpoint('provisions/provisions/:id/show'),
        UPDATE_PROVISION: buildEndpoint('provisions/provisions/:id/update'),
        DELETE_PROVISION: buildEndpoint('provisions/provisions/:id/delete'),
        ACTIVE_PROVISION: buildEndpoint('provisions/provisions/:id/active')
    },
    PROVISIONS_RATES: {
        GET_PROVISIONS_RATES_BY_PROVISIONS: buildEndpoint(
            'provisions/provisions-rates/:provision_id/by-provisions'
        ),
        STORE_PROVISIONS_RATE: buildEndpoint('provisions/provisions-rates/store'),
        CREATE_PROVISIONS_RATE: buildEndpoint('provisions/provisions-rates/create'),
        DELETE_PROVISIONS_RATE: buildEndpoint('provisions/provisions-rates/:id/delete'),
        EDIT_PROVISIONS_RATE: buildEndpoint('provisions/provisions-rates/:id/edit'),
        SHOW_PROVISIONS_RATE: buildEndpoint('provisions/provisions-rates/:id/show'),
        UPDATE_PROVISIONS_RATE: buildEndpoint('provisions/provisions-rates/:id/update'),
        ACTIVE_PROVISIONS_RATE: buildEndpoint('provisions/provisions-rates/:id/active')
    },
    BRANDS: {
        GET_BRANDS: buildEndpoint('carriers/brands'),
        CREATE_BRAND: buildEndpoint('carriers/brands/create'),
        STORE_BRAND: buildEndpoint('carriers/brands/store'),
        EDIT_BRAND: buildEndpoint('carriers/brands/:id/edit'),
        SHOW_BRAND: buildEndpoint('carriers/brands/:id/show'),
        UPDATE_BRAND: buildEndpoint('carriers/brands/:id/update'),
        DELETE_BRAND: buildEndpoint('carriers/brands/:id/delete'),
        ACTIVE_BRAND: buildEndpoint('carriers/brands/:id/active')
    },

    CAUSE_NOTE: {
        GET_CAUSE_NOTES: buildEndpoint('cause-notes/cause-notes'),
        CREATE_CAUSE_NOTE: buildEndpoint('cause-notes/cause-notes/create'),
        STORE_CAUSE_NOTE: buildEndpoint('cause-notes/cause-notes/store'),
        EDIT_CAUSE_NOTE: buildEndpoint('cause-notes/cause-notes/:id/edit'),
        SHOW_CAUSE_NOTE: buildEndpoint('cause-notes/cause-notes/:id/show'),
        UPDATE_CAUSE_NOTE: buildEndpoint('cause-notes/cause-notes/:id/update'),
        DELETE_CAUSE_NOTE: buildEndpoint('cause-notes/cause-notes/:id/delete'),
        ACTIVE_CAUSE_NOTE: buildEndpoint('cause-notes/cause-notes/:id/active')
    },
    VEHICLE_MODELS: {
        GET_VEHICLE_MODELS: buildEndpoint('carriers/vehicle-models'),
        CREATE_VEHICLE_MODEL: buildEndpoint('carriers/vehicle-models/create'),
        STORE_VEHICLE_MODEL: buildEndpoint('carriers/vehicle-models/store'),
        EDIT_VEHICLE_MODEL: buildEndpoint('carriers/vehicle-models/:id/edit'),
        SHOW_VEHICLE_MODEL: buildEndpoint('carriers/vehicle-models/:id/show'),
        UPDATE_VEHICLE_MODEL: buildEndpoint('carriers/vehicle-models/:id/update'),
        DELETE_VEHICLE_MODEL: buildEndpoint('carriers/vehicle-models/:id/delete'),
        ACTIVE_VEHICLE_MODEL: buildEndpoint('carriers/vehicle-models/:id/active')
    },
    FUEL_CONSUMPTIONS: {
        GET_FUEL_CONSUMPTIONS: buildEndpoint('sitrack/consumptions'),
        GET_FUEL_CONSUMPTIONS_BY_TRUCK: buildEndpoint('sitrack/consumptions/:id'),
        GET_EXCEL_FUEL_CONSUMPTIONS: buildEndpoint('sitrack/consumptions/excel'),
        GET_EXCEL_FUEL_CONSUMPTIONS_BY_TRUCK: buildEndpoint('sitrack/consumptions/:id/excel-by-truck')
    },
    RUNNERS: {
        GET_ALL: buildEndpoint('auths/runners/:transportation_order_item_id'),
        ASSIGN_RUNNER: buildEndpoint('auths/assign-runner')
    },
    PAYMENT_METHODS: {
        GET_PAYMENT_METHODS: buildEndpoint('payments/payment-methods'),
        STORE_PAYMENT_METHOD: buildEndpoint('payments/payment-methods/store'),
        EDIT_PAYMENT_METHOD: buildEndpoint('payments/payment-methods/:id/edit'),
        UPDATE_PAYMENT_METHOD: buildEndpoint('payments/payment-methods/:id/update'),
        DELETE_PAYMENT_METHOD: buildEndpoint('payments/payment-methods/:id/delete'),
        ACTIVE_PAYMENT_METHOD: buildEndpoint('payments/payment-methods/:id/active')
    },
    PAYMENT_CONDITIONS: {
        GET_PAYMENT_CONDITIONS: buildEndpoint('payments/payment-conditions'),
        STORE_PAYMENT_CONDITION: buildEndpoint('payments/payment-conditions/store'),
        EDIT_PAYMENT_CONDITION: buildEndpoint('payments/payment-conditions/:id/edit'),
        UPDATE_PAYMENT_CONDITION: buildEndpoint('payments/payment-conditions/:id/update'),
        DELETE_PAYMENT_CONDITION: buildEndpoint('payments/payment-conditions/:id/delete'),
        ACTIVE_PAYMENT_CONDITION: buildEndpoint('payments/payment-conditions/:id/active')
    },
    PAYMENTS: {
        GET_PAYMENT_METHODS: buildEndpoint('payments/methods/'),
        GET_PAYMENT_METHOD: buildEndpoint('payments/methods/:id'),
        GET_PAYMENT_CONDITIONS: buildEndpoint('payments/conditions/'),
        GET_PAYMENT_CONDITION: buildEndpoint('payments/conditions/:id')
    },

    PAYMENT_STATUS: {
        GET_PAYMENT_STATUSES: buildEndpoint('payment-statuses/payment-statuses'),
        GET_PAYMENT_STATUS: buildEndpoint('payment-statuses/payment-statuses/:id/get'),
        GET_PAYMENT_DOCUMENT: buildEndpoint('dispatch-programs/payment-status/:id/document'),
        GENERATE_PAYMENT_STATUS: buildEndpoint('payment-statuses/payment-statuses/generate'),
        CREATE_PAYMENT_STATUS: buildEndpoint('dispatch-programs/payment-status/create'),
        STORE_PAYMENT_STATUS: buildEndpoint('dispatch-programs/payment-status/store'),
        EDIT_PAYMENT_STATUS: buildEndpoint('payment-statuses/payment-statuses/:id/edit'),
        SHOW_PAYMENT_STATUS: buildEndpoint('dispatch-programs/payment-status/::id/show'),
        UPDATE_PAYMENT_STATUS: buildEndpoint('payment-statuses/payment-statuses/:id/update'),
        DELETE_PAYMENT_STATUS: buildEndpoint('payment-statuses/payment-statuses/:id/delete'),
        CAN_CHANGE_PAYMENT_STATUS: buildEndpoint('payment-statuses/payment-statuses/:id/:status/can-change-status'),
        CHANGE_STATUS_PAYMENT_STATUS: buildEndpoint('payment-statuses/payment-statuses/:id/change-status'),
        CHANGE_REVIEW_STATUS_PAYMENT_STATUS: buildEndpoint('payment-statuses/payment-statuses/:id/change-review-status'),
        CHANGE_APPROVED_STATUS_PAYMENT_STATUS: buildEndpoint('payment-statuses/payment-statuses/:id/change-approved-status'),
        CHANGE_ANNULLED_STATUS_PAYMENT_STATUS: buildEndpoint('payment-statuses/payment-statuses/:id/change-annulled-status'),
        CHANGE_DRAFT_STATUS_PAYMENT_STATUS: buildEndpoint('payment-statuses/payment-statuses/:id/change-draft-status'),
    },
    PAYMENT_STATUS_DETAIL: {
        GET_PAYMENT_STATUS_DETAILS_BY_PAYMENT_STATUS: buildEndpoint('payment-statuses/payment-status-details/:payment_status_id/by-payment-status'),
        
    },

    TAX: {
        GET_TAXES: buildEndpoint('taxes/taxes'),
        STORE_TAX: buildEndpoint('taxes/taxes/store'),
        EDIT_TAX: buildEndpoint('taxes/taxes/:id/edit'),
        CREATE_TAX: buildEndpoint('taxes/taxes/create'),
        SHOW_TAX: buildEndpoint('taxes/taxes/:id/show'),
        UPDATE_TAX: buildEndpoint('taxes/taxes/:id/update'),
        DELETE_TAX: buildEndpoint('taxes/taxes/:id/delete'),
        ACTIVE_TAX: buildEndpoint('taxes/taxes/:id/active'),
    },

    TAX_DOCUMENT: {
        GET_TAX_DOCUMENT: buildEndpoint('tax-documents/tax-documents'),
        EDIT_TAX_DOCUMENT: buildEndpoint('tax-documents/tax-documents/:id/edit'),
        SHOW_TAX_DOCUMENT: buildEndpoint('tax-documents/tax-documents/:id/show'),
        DELETE_TAX_DOCUMENT: buildEndpoint('tax-documents/tax-documents/:id/delete'),
        ACCOUNTED: buildEndpoint('tax-documents/tax-documents/:id/change-to-accounted'),
        ANNULLED: buildEndpoint('tax-documents/tax-documents/:id/change-to-annulled'),
        DRAFT: buildEndpoint('tax-documents/tax-documents/:id/change-to-draft'),
        ACTIVE_TAX_DOCUMENT: buildEndpoint('tax-documents/tax-documents/:id/active'),

        //Sales Invoice
        CREATE_SALES_INVOICE: buildEndpoint('tax-documents/tax-documents/sales-invoice/create'),
        STORE_SALES_INVOICE: buildEndpoint('tax-documents/tax-documents/sales-invoice/store'),
        GET_PAYMENT_STATUSES_BY_CLIENT_SOCIETY: buildEndpoint('tax-documents/tax-documents/sales-invoice/payment-statuses/by-society-client/:society_id/:client_id'),
        UPDATE_SALES_INVOICE: buildEndpoint('tax-documents/tax-documents/sales-invoice/:id/update'),

        //Note
        CREATE_NOTE: buildEndpoint('tax-documents/tax-documents/note/create'),
        GET_CAUSE_NOTE: buildEndpoint('tax-documents/tax-documents/note/:note_type>/cause-note-by-note-type'),
        STORE_NOTE: buildEndpoint('tax-documents/tax-documents/note/store'),
        UPDATE_NOTE: buildEndpoint('tax-documents/tax-documents/note/:id/update'),
        CALCULATE_TOTAL_NOTE: buildEndpoint('tax-documents/tax-documents/note/calculate-total'),
    },

    TAX_DOCUMENT_DETAIL: {

        GET_TAX_DOCUMENT_DETAILS_BY_TAX_DOCUMENT: buildEndpoint('tax-documents/tax-document-detail/:id/by-tax-document'),
        DELETE_TAX_DOCUMENT_BY_TAX_DOCUMENT: buildEndpoint('tax-documents/tax-document-detail/:id/delete/:payment_status_id'),
        GET_TAX_DOCUMENT_DETAILS: buildEndpoint('tax-documents/tax-document-detail/:id/details'),
    },

    
    TAX_DOCUMENT_HISTORY: {

        GET_TAX_DOCUMENT_HISTORIES_BY_TAX_DOCUMENT: buildEndpoint('tax-documents/tax-document-history/:tax_document_id'),
    },


    TRANSPORTATION_ORDERS: {
        GET_EXCEL_TRANSPORTATION_ORDERS: buildEndpoint(
            'transportation-orders/transportation-orders/excel'
        ),
        GET_TRANSPORTATION_ORDERS: buildEndpoint('transportation-orders/transportation-orders'),
        CREATE_TRANSPORTATION_ORDER: buildEndpoint(
            'transportation-orders/transportation-orders/create'
        ),
        STORE_TRANSPORTATION_ORDER: buildEndpoint(
            'transportation-orders/transportation-orders/store'
        ),
        SHOW_TRANSPORTATION_ORDER: buildEndpoint(
            'transportation-orders/transportation-orders/:id/show'
        ),
        EDIT_TRANSPORTATION_ORDER: buildEndpoint(
            'transportation-orders/transportation-orders/:id/edit'
        ),
        UPDATE_TRANSPORTATION_ORDER: buildEndpoint(
            'transportation-orders/transportation-orders/:id/update'
        ),
        UPDATE_TRANSPORTATION_ORDER_RATE_RUNNER: buildEndpoint(
            'transportation-orders/transportation-orders/:id/update-rates'
        ),
        DELETE_TRANSPORTATION_ORDER: buildEndpoint(
            'transportation-orders/transportation-orders/:id/delete'
        ),
        SHOW_QUOTE_TRANSPORTATION_ORDER: buildEndpoint(
            'transportation-orders/transportation-orders/:id/show-quote'
        ),
        CHANGE_TO_DISPATCH_STATUS_TRANSPORTATION_ORDER: buildEndpoint(
            'transportation-orders/transportation-orders/:id/change-status-to-dispatch'
        ),
        CHANGE_TO_FINISH_STATUS_TRANSPORTATION_ORDER: buildEndpoint(
            'transportation-orders/transportation-orders/:id/change-status-to-finish'
        ),
        CHANGE_TO_ANNULLED_STATUS_TRANSPORTATION_ORDER: buildEndpoint(
            'transportation-orders/transportation-orders/:id/change-status-to-annulled'
        ),

        //Tranportation Order Items
        GET_TRANSPORTATION_ORDER_ITEMS_BY_ORDER: buildEndpoint(
            'transportation-orders/transportation-order-items/:id/by-order'
        ),
        GET_TRANSPORTATION_ORDER_ITEM: buildEndpoint(
            'transportation-orders/transportation-order-items/:id'
        ),
        CREATE_TRANSPORTATION_ORDER_ITEM: buildEndpoint(
            'transportation-orders/transportation-order-items/:id/create'
        ),
        STORE_TRANSPORTATION_ORDER_ITEM: buildEndpoint(
            'transportation-orders/transportation-order-items/store'
        ),
        EDIT_TRANSPORTATION_ORDER_ITEM: buildEndpoint(
            'transportation-orders/transportation-order-items/:id/edit'
        ),
        SHOW_TRANSPORTATION_ORDER_ITEM: buildEndpoint(
            'transportation-orders/transportation-order-items/:id/show'
        ),
        UPDATE_TRANSPORTATION_ORDER_ITEM: buildEndpoint(
            'transportation-orders/transportation-order-items/:id/update'
        ),
        DELETE_TRANSPORTATION_ORDER_ITEM: buildEndpoint(
            'transportation-orders/transportation-order-items/:id/delete'
        ),
        HAS_ALL_FINISHED_TRANSPORTATION_ORDER_ITEMS: buildEndpoint(
            'transportation-orders/transportation-order-items/:id/:status_detail_toi/has-all-finished-transportation-order-items'
        ),
        CHANGE_STATUS_TRANSPORTATION_ORDER_ITEM: buildEndpoint(
            'transportation-orders/transportation-order-items/:id/change-status'
        ),
        SPLIT_TRANSPORTATION_ORDER_ITEM: buildEndpoint(
            'transportation-orders/transportation-order-items/split'
        ),
        GET_RATES_TRANSPORTATION_ORDER_ITEM: buildEndpoint(
            'transportation-orders/transportation-order-items/:id/edit-rates'
        ),
        UPDATE_RATES_TRANSPORTATION_ORDER_ITEM: buildEndpoint(
            'transportation-orders/transportation-order-items/:id/update-rates'
        ),

        GET_TRANSPORTATION_SUB_ORDER_ITEMS_BY_ITEM: buildEndpoint(
            'transportation-orders/transportation-sub-order-items/:id/by-item'
        ),
        GET_TRANSPORTATION_SUB_ORDER_ITEM: buildEndpoint(
            'transportation-orders/transportation-sub-order-items/:id'
        ),
        CREATE_TRANSPORTATION_SUB_ORDER_ITEM: buildEndpoint(
            'transportation-orders/transportation-sub-order-items/create'
        ),

        STORE_TRANSPORTATION_SUB_ORDER_ITEMS: buildEndpoint(
            'transportation-orders/transportation-sub-order-items/store'
        ),
        EDIT_TRANSPORTATION_SUB_ORDER_ITEM: buildEndpoint(
            'transportation-orders/transportation-sub-order-items/:id/edit'
        ),
        SHOW_TRANSPORTATION_SUB_ORDER_ITEM: buildEndpoint(
            'transportation-orders/transportation-sub-order-items/:id/show'
        ),
        UPDATE_TRANSPORTATION_SUB_ORDER_ITEM: buildEndpoint(
            'transportation-orders/transportation-sub-order-items/:id/update'
        ),
        DELETE_TRANSPORTATION_SUB_ORDER_ITEM: buildEndpoint(
            'transportation-orders/transportation-sub-order-items/:id/delete'
        ),
        DISPATCH_TRANSPORTATION_SUB_ORDER_ITEM: buildEndpoint(
            'transportation-orders/transportation-sub-order-items/:id/dispatch'
        )
    },

    QUOTES: {
        // quote requests
        GET_QUOTES: buildEndpoint('quotes/quotes'),
        GET_EXCEL_QUOTES: buildEndpoint('quotes/quotes/excel'),
        GET_QUOTE: buildEndpoint('quotes/quotes/:id'),
        CREATE_QUOTE: buildEndpoint('quotes/quotes/create'),
        STORE_QUOTE: buildEndpoint('quotes/quotes/store'),
        EDIT_QUOTE: buildEndpoint('quotes/quotes/:id/edit'),
        UPDATE_QUOTE: buildEndpoint('quotes/quotes/:id/update'),
        SHOW_QUOTE: buildEndpoint('quotes/quotes/:id/show'),
        DELETE_QUOTE: buildEndpoint('quotes/quotes/:id/delete'),
        REPEAT_QUOTE: buildEndpoint('quotes/quotes/repeat'),
        DOCUMENT_QUOTE: buildEndpoint('quotes/quotes/:id/document'),
        CHANGE_CHECK_ROUTES_DOCUMENT_QUOTE: buildEndpoint('quotes/quotes/:id/document-routes'),
        CONFIRM_QUOTE: buildEndpoint('quotes/quotes/:id/confirm'),
        REJECT_QUOTE: buildEndpoint('quotes/quotes/:id/reject'),

        CLIENT_REVIEW_QUOTE: buildEndpoint('quotes/quotes/:id/client-review'),
        OPERATION_REVIEW_QUOTE: buildEndpoint('quotes/quotes/:id/operation-review'),

        PREPARATION_QUOTE: buildEndpoint('quotes/quotes/:id/preparation'),

        // quote details
        GET_TRANSPORTATION_QUOTE_DETAILS_BY_REQUEST: buildEndpoint(
            'quotes/transportation-quote-details/:id/by-request'
        ),
        GET_TRANSPORTATION_QUOTE_DETAIL: buildEndpoint('quotes/transportation-quote-details/:id'),
        CREATE_TRANSPORTATION_QUOTE_DETAIL: buildEndpoint(
            'quotes/transportation-quote-details/create'
        ),
        STORE_TRANSPORTATION_QUOTE_DETAIL: buildEndpoint(
            'quotes/transportation-quote-details/store'
        ),
        GET_QUOTE_ROUTE_SEGMENTS_TO_QUOTE_DETAIL: buildEndpoint(
            'quotes/transportation-quote-details/:quote_id/:route_segment_id/get-quote-rs'
        ),
        EDIT_TRANSPORTATION_QUOTE_DETAIL: buildEndpoint(
            'quotes/transportation-quote-details/:id/edit'
        ),
        SHOW_TRANSPORTATION_QUOTE_DETAIL: buildEndpoint(
            'quotes/transportation-quote-details/:id/show'
        ),
        UPDATE_TRANSPORTATION_QUOTE_DETAIL: buildEndpoint(
            'quotes/transportation-quote-details/:id/update'
        ),
        DELETE_TRANSPORTATION_QUOTE_DETAIL: buildEndpoint(
            'quotes/transportation-quote-details/:id/delete'
        )
    },
    DISPATCH_PROGRAMS: {
        CAN_CHANGE_DISPATCH_PROGRAM: buildEndpoint('dispatch-programs/dispatch-programs/:id/:status/can-change-status'),
        CHANGE_STATUS_DISPATCH_PROGRAM: buildEndpoint('dispatch-programs/dispatch-programs/:id/change-status'),
        CHANGE_TO_DISPATCH_STATUS_DISPATCH_PROGRAM: buildEndpoint('dispatch-programs/dispatch-programs/:id/change-status-to-dispatch'),
        CHANGE_TO_FINISH_STATUS_DISPATCH_PROGRAM: buildEndpoint('dispatch-programs/dispatch-programs/:id/change-status-to-finish'),
        CHANGE_TO_NULLIFIED_STATUS_DISPATCH_PROGRAM: buildEndpoint('dispatch-programs/dispatch-programs/:id/change-status-to-nullified'),
        //CHANGE_TO_STATUS_INTERLOCUTOR: buildEndpoint('dispatch-programs/dispatch-programs/:id/change-status-to-interlocutor'),
        GET_EXCEL_DISPATCH_PROGRAMS: buildEndpoint('dispatch-programs/dispatch-programs/excel'),
        GET_DISPATCH_PROGRAMS: buildEndpoint('dispatch-programs/dispatch-programs'),
        LOAD_BULK: buildEndpoint('dispatch-programs/dispatch-programs/load-bulk'),
        HAS_ALL_FINISHED_DISPATCH_PROGRAM_ITEMS: buildEndpoint(
            'dispatch-programs/dispatch-program-items/:id/:status_detail_dpi/has-all-finished-dispatch-program-items'
        ),
        HAS_ALL_FINISHED_DISPATCH_PROGRAM_ROWS: buildEndpoint(
            'dispatch-programs/dispatch-program-items/has-all-finished-dispatch-program-rows'
        ),
        CREATE_DISPATCH_PROGRAM: buildEndpoint('dispatch-programs/dispatch-programs/create'),
        STORE_DISPATCH_PROGRAM: buildEndpoint('dispatch-programs/dispatch-programs/store'),
        SHOW_DISPATCH_PROGRAM: buildEndpoint('dispatch-programs/dispatch-programs/:id/show'),
        EDIT_DISPATCH_PROGRAM: buildEndpoint('dispatch-programs/dispatch-programs/:id/edit'),
        UPDATE_DISPATCH_PROGRAM: buildEndpoint('dispatch-programs/dispatch-programs/:id/update'),
        DELETE_DISPATCH_PROGRAM: buildEndpoint('dispatch-programs/dispatch-programs/:id/delete'),

        SHOW_TRANSPORTATION_ORDER_DISPATCH_PROGRAM: buildEndpoint(
            'dispatch-programs/dispatch-programs/:id/show-transportation-order'
        ),
        CHANGE_STATUSES_ROWS_TO_DISPATCH_PROGRAM_ITEM: buildEndpoint(
            'dispatch-programs/dispatch-program-items/change-rows-status'
        ),
        MASIVE_DELETE_ROWS_DISPATCH_PROGRAM_ITEMS: buildEndpoint(
            'dispatch-programs/dispatch-program-items/masive-rows-delete'
        ),

        GET_TRANSPORTATION_SUB_ORDER_ITEMS_DISPATCH_PROGRAM: buildEndpoint(
            'dispatch-programs/dispatch-programs/:id/transportation-sub-order-items'
        ),

        GET_DISPATCH_PROGRAM_ITEMS_BY_DISPATCH: buildEndpoint(
            'dispatch-programs/dispatch-program-items/:id/by-dispatch'
        ),

        GET_DISPATCH_PROGRAM_ITEMS_BY_TRANSPORTATION_SUB_ORDER_ITEM: buildEndpoint(
            'dispatch-programs/dispatch-program-items/:id/by-transportation-sub-order-item'
        ),
        GET_EXCEL_DISPATCH_PROGRAM_ITEMS_BY_TRANSPORTATION_SUB_ORDER_ITEM: buildEndpoint(
            'dispatch-programs/excel-dispatch-program-items/:id/by-transportation-sub-order-item'
        ),
        SPLIT_TRANSPORTATION_SUB_ORDER_ITEM: buildEndpoint(
            'dispatch-programs/dispatch-programs/:id/split-transportation-sub-order-item'
        ),

        STORE_SPLIT_TRANSPORTATION_SUB_ORDER_ITEM: buildEndpoint(
            'dispatch-programs/dispatch-programs/store-split-transportation-sub-order-item'
        ),

        // DISPATCH PROGRAM ITEMS

        GET_DISPATCH_PROGRAM_ITEM: buildEndpoint('dispatch-programs/dispatch-program-items/:id'),
        CREATE_DISPATCH_PROGRAM_ITEM: buildEndpoint(
            'dispatch-programs/dispatch-program-items/create'
        ),
        STORE_DISPATCH_PROGRAM_ITEM: buildEndpoint(
            'dispatch-programs/dispatch-program-items/store'
        ),
        EDIT_DISPATCH_PROGRAM_ITEM: buildEndpoint(
            'dispatch-programs/dispatch-program-items/:id/edit'
        ),
        SHOW_DISPATCH_PROGRAM_ITEM: buildEndpoint(
            'dispatch-programs/dispatch-program-items/:id/show'
        ),
        UPDATE_DISPATCH_PROGRAM_ITEM: buildEndpoint(
            'dispatch-programs/dispatch-program-items/:id/update'
        ),
        DELETE_DISPATCH_PROGRAM_ITEM: buildEndpoint(
            'dispatch-programs/dispatch-program-items/:id/delete'
        ),

        PREPARATION_DISPATCH_PROGRAM_ITEM: buildEndpoint(
            'dispatch-programs/dispatch-program-items/:id/preparation'
        ),
        PREPARATION_DISPATCH_PROGRAM_ROWS: buildEndpoint(
            'dispatch-programs/dispatch-program-items/preparation/rows'
        ),
        PLANNING_DISPATCH_PROGRAM_ITEM: buildEndpoint(
            'dispatch-programs/dispatch-program-items/:id/planification'
        ),
        PLANNING_DISPATCH_PROGRAM_ROWS: buildEndpoint(
            'dispatch-programs/dispatch-program-items/planification/rows'
        ),
        DISPATCH_DISPATCH_PROGRAM_ITEM: buildEndpoint(
            'dispatch-programs/dispatch-program-items/:id/dispatch'
        ),
        DISPATCH_DISPATCH_PROGRAM_ROWS: buildEndpoint(
            'dispatch-programs/dispatch-program-items/dispatch/rows'
        ),
        ANNULLED_DISPATCH_PROGRAM_ITEM: buildEndpoint(
            'dispatch-programs/dispatch-program-items/:id/annulled'
        ),
        FINISH_DISPATCH_PROGRAM_ITEM: buildEndpoint(
            'dispatch-programs/dispatch-program-items/:id/finish'
        ),
        FINISH_DISPATCH_PROGRAM_ROWS: buildEndpoint(
            'dispatch-programs/dispatch-program-items/finish/rows'
        ),
        GET_DISPATCH_PROGRAM_ITEM_DAILY_CARRIERS_AVAILABLE: buildEndpoint(
            'dispatch-programs/dispatch-program-items/:id/daily-carriers-available'
        ),
        GET_DISPATCH_PROGRAM_ITEM_GUIDE: buildEndpoint(
            'dispatch-programs/dispatch-program-items/:id/guide'
        ),

        SYNC_DISPATCH_PROGRAM_DAILY_CARRIERS: buildEndpoint(
            'dispatch-programs/dispatch-program-daily-carriers/store'
        )
    },
    
    DISPATCH_PROGRAM_DOCUMENTS: {
        GET_DISPATCH_PROGRAM_DOCUMENTS: buildEndpoint(
            'dispatch-programs/dispatch-program-documents/:dispatch_program_id'
        ),
        UPDATE_DISPATCH_PROGRAM_DOCUMENTS: buildEndpoint(
            'dispatch-programs/dispatch-program-documents/:dispatch_program_id/update'
        )
    },
    DAILY_CARRIERS: {
        GET_DAILY_CARRIERS: buildEndpoint('carriers/daily-carriers'),
        GET_DAILY_CARRIER: buildEndpoint('carriers/daily-carriers/:id'),
        CREATE_DAILY_CARRIER: buildEndpoint('carriers/daily-carriers/create'),
        STORE_DAILY_CARRIER: buildEndpoint('carriers/daily-carriers/store'),
        EDIT_DAILY_CARRIER: buildEndpoint('carriers/daily-carriers/:id/edit'),
        SHOW_DAILY_CARRIER: buildEndpoint('carriers/daily-carriers/:id/show'),
        UPDATE_DAILY_CARRIER: buildEndpoint('carriers/daily-carriers/:id/update'),
        DELETE_DAILY_CARRIER: buildEndpoint('carriers/daily-carriers/:id/delete')
    },
    CONTRACTS: {
        GET_CONTRACTS: buildEndpoint('calendars/contracts'),
        STORE_CONTRACTS: buildEndpoint('calendars/contracts/store'),
        CREATE_CONTRACTS: buildEndpoint('calendars/contracts/create'),
        DELETE_CONTRACTS: buildEndpoint('calendars/contracts/:id/delete'),
        EDIT_CONTRACTS: buildEndpoint('calendars/contracts/:id/edit'),
        UPDATE_CONTRACTS: buildEndpoint('calendars/contracts/:id/update'),
        ACTIVE_CONTRACTS: buildEndpoint('calendars/contracts/:id/active')
    },
    SALES_INVOICE: {
        GET_SALES_INVOICES: buildEndpoint('sales-invoices/sales-invoices'),
        STORE_SALES_INVOICE: buildEndpoint('sales-invoices/sales-invoices/store'),
        EDIT_SALES_INVOICE: buildEndpoint('sales-invoices/sales-invoices/:id/edit'),
        CREATE_SALES_INVOICE: buildEndpoint('sales-invoices/sales-invoices/create'),
        SHOW_SALES_INVOICE: buildEndpoint('sales-invoices/sales-invoices/:id/show'),
        UPDATE_SALES_INVOICE: buildEndpoint('sales-invoices/sales-invoices/:id/update'),
        DELETE_SALES_INVOICE: buildEndpoint('sales-invoices/sales-invoices/:id/delete'),
        ACTIVE_SALES_INVOICE: buildEndpoint('sales-invoices/sales-invoices/:id/active'),
        GET_SALES_INVOICE: buildEndpoint('sales-invoices/sales-invoices/:id/get'),
        GET_SALES_INVOICE_DETAILS: buildEndpoint('sales-invoices/sales-invoices/:id/details'),
        DRAFT: buildEndpoint('sales-invoices/sales-invoices/:id/change-to-draft'),
        ACCOUNTED: buildEndpoint('sales-invoices/sales-invoices/:id/change-to-accounted'),
        ANNULLED: buildEndpoint('sales-invoices/sales-invoices/:id/change-to-annulled'),
        RECALCULATE_FROM_DELIVERIES: buildEndpoint('sales-invoices/sales-invoices/:id/recalculate-from-deliveries'),
        GET_PAYMENT_STATUSES_BY_CLIENT_SOCIETY: buildEndpoint('sales-invoices/sales-invoices/payment-statuses/by-society-client/:society_id/:client_id'),
    },
    
    SALES_INVOICE_DETAIL: {
        GET_SALES_INVOICE_DETAILS_BY_SALES_INVOICE: buildEndpoint('sales-invoices/sales-invoice-detail/:id/by-sales-invoice'),
        DELETE_SALES_INVOICE_DETAIL: buildEndpoint('sales-invoices/sales-invoice-detail/:id/delete')
    },
    SALES_INVOICE_HISTORY: {
        GET_SALES_INVOICE_HISTORIES_BY_INVOICE: buildEndpoint('sales-invoices/sales-invoice-history/:sales_invoice_id'),
    },
    LIQUIDATIONS: {
        GET_LIQUIDATIONS: buildEndpoint('calendars/liquidations'),
        STORE_LIQUIDATIONS: buildEndpoint('calendars/liquidations/store'),
        CREATE_LIQUIDATIONS: buildEndpoint('calendars/liquidations/create'),
        DELETE_LIQUIDATIONS: buildEndpoint('calendars/liquidations/:id/delete'),
        EDIT_LIQUIDATIONS: buildEndpoint('calendars/liquidations/:id/edit'),
        UPDATE_LIQUIDATIONS: buildEndpoint('calendars/liquidations/:id/update'),
        ACTIVE_LIQUIDATIONS: buildEndpoint('calendars/liquidations/:id/active'),
        SHOW_LIQUIDATION: buildEndpoint('calendars/liquidations/:id/show'),
        APPROVED_LIQUIDATION: buildEndpoint('calendars/liquidations/:id/approved'),
        DOCUMENT_LIQUIDATION: buildEndpoint('calendars/liquidations/:id/document'),
    },
    BONUSES: {
        GET_BONUSES: buildEndpoint('calendars/bonus'),
        STORE_BONUSES: buildEndpoint('calendars/bonus/store'),
        CREATE_BONUSES: buildEndpoint('calendars/bonus/create'),
        DELETE_BONUSES: buildEndpoint('calendars/bonus/:id/delete'),
        EDIT_BONUSES: buildEndpoint('calendars/bonus/:id/edit'),
        UPDATE_BONUSES: buildEndpoint('calendars/bonus/:id/update'),
        ACTIVE_BONUSES: buildEndpoint('calendars/bonus/:id/active')
    },
    BONUS_RATES: {
        GET_BONUS_RATES_BY_BONUS: buildEndpoint('calendars/bonus-rates/:bonus_id/by-bonus'),
        STORE_BONUS_RATE: buildEndpoint('calendars/bonus-rates/store'),
        CREATE_BONUS_RATE: buildEndpoint('calendars/bonus-rates/create'),
        DELETE_BONUS_RATE: buildEndpoint('calendars/bonus-rates/:id/delete'),
        EDIT_BONUS_RATE: buildEndpoint('calendars/bonus-rates/:id/edit'),
        UPDATE_BONUS_RATE: buildEndpoint('calendars/bonus-rates/:id/update'),
    },
    DEDUCTIONS: {
        GET_DEDUCTIONS: buildEndpoint('calendars/deductions'),
        STORE_DEDUCTIONS: buildEndpoint('calendars/deductions/store'),
        CREATE_DEDUCTIONS: buildEndpoint('calendars/deductions/create'),
        DELETE_DEDUCTIONS: buildEndpoint('calendars/deductions/:id/delete'),
        EDIT_DEDUCTIONS: buildEndpoint('calendars/deductions/:id/edit'),
        UPDATE_DEDUCTIONS: buildEndpoint('calendars/deductions/:id/update'),
        ACTIVE_DEDUCTIONS: buildEndpoint('calendars/deductions/:id/active')
    },
    DEDUCTION_RATES: {
        GET_DEDUCTION_RATES_BY_DEDUCTION: buildEndpoint('calendars/deduction-rates/:deduction_id/by-deduction'),
        STORE_DEDUCTION_RATE: buildEndpoint('calendars/deduction-rates/store'),
        CREATE_DEDUCTION_RATE: buildEndpoint('calendars/deduction-rates/create'),
        DELETE_DEDUCTION_RATE: buildEndpoint('calendars/deduction-rates/:id/delete'),
        EDIT_DEDUCTION_RATE: buildEndpoint('calendars/deduction-rates/:id/edit'),
        UPDATE_DEDUCTION_RATE: buildEndpoint('calendars/deduction-rates/:id/update'),
        ACTIVE_DEDUCTIONS: buildEndpoint('calendars/deductions/:id/active')
    },
    CALCULATED_FIELD: {
        CREATE_CALCULATED_FIELD: buildEndpoint('calendars/calculated-field/:id/:type/create')
    },
    HOLIDAYS: {
        GET_HOLIDAYS: buildEndpoint('calendars/holidays'),
        STORE_HOLIDAYS: buildEndpoint('calendars/holidays/store'),
        CREATE_HOLIDAY: buildEndpoint('calendars/holidays/create'),
        DELETE_HOLIDAY: buildEndpoint('calendars/holidays/:id/delete'),
        EDIT_HOLIDAY: buildEndpoint('calendars/holidays/:id/edit'),
        UPDATE_HOLIDAY: buildEndpoint('calendars/holidays/:id/update'),
        ACTIVE_HOLIDAY: buildEndpoint('calendars/holidays/:id/active'),
        GET_HOLIDAYS_BY_DATE: buildEndpoint('calendars/holidays/by-date'),
        GET_HOLIDAYS_BY_FIRST_AND_LAST_DATE: buildEndpoint('calendars/holidays/by-first-and-last-date')
    },
    EVENTS: {
        GET_EVENTS: buildEndpoint('calendars/events'),
        GET_EVENTS_BY_WORKER: buildEndpoint('calendars/events/event-by-worker'),
        GET_EVENT_BY_ID: buildEndpoint('calendars/events/event-by-id/:event_id'),
        CREATE_EXPENSE: buildEndpoint('calendars/events/create-expenses'),
        STORE_EVENTS: buildEndpoint('calendars/events/store'),
        CREATE_EVENT: buildEndpoint('calendars/events/create'),
        EDIT_EVENT: buildEndpoint('calendars/events/edit'),
        UPDATE_EVENT: buildEndpoint('calendars/events/:event_id/update'),
        UPDATE_SHIFT_WORK_EVENT: buildEndpoint('calendars/events/:event_id/update-shift-work'),
        UPDATE_ALL_SHIFT_WORK_EVENT: buildEndpoint('calendars/events/all-update-shift-work'),
        UPDATE_NEXT_SHIFT_WORK_EVENT: buildEndpoint(
            'calendars/events/:date/next-update-shift-work'
        ),
        CREATE_SHIFT_WORK_EVENT: buildEndpoint('calendars/events/create-shift-work'),
        DELETE_EVENT: buildEndpoint('calendars/events/:event_id/delete-event'),
        DELETE_ONE_DAY_SHIFT_WORK_EVENT: buildEndpoint(
            'calendars/events/:event_id/:date/delete-one-day-shiftwork'
        ),
        DELETE_NEXT_DAYS_SHIFT_WORK_EVENT: buildEndpoint(
            'calendars/events/:event_id/:date/delete-next-days-shiftwork'
        ),
        TRAVEL_EXPENSES_BY_EVENTS: buildEndpoint(
            'calendars/events/travel-expenses-by-events'
        ),
        GET_HOLIDAYS_EVENTS: buildEndpoint(
            'calendars/events/holidays-events'
        ),
        GET_SUNDAYS_EVENTS: buildEndpoint(
            'calendars/events/sundays-events'
        ),
    },
    WORKERS: {
        GET_WORKERS: buildEndpoint('calendars/workers'),
        // GET_WORKER: buildEndpoint('calendars/workers/:id'),
        CREATE_WORKER: buildEndpoint('calendars/workers/create'),
        STORE_WORKER: buildEndpoint('calendars/workers/store'),
        EDIT_WORKER: buildEndpoint('calendars/workers/:id/edit'),
        SHOW_WORKER: buildEndpoint('calendars/workers/:id/calendar'),
        UPDATE_WORKER: buildEndpoint('calendars/workers/:id/update'),
        DELETE_WORKER: buildEndpoint('calendars/workers/:id/delete'),
        ACTIVE_WORKER: buildEndpoint('calendars/workers/:id/active'),
        FIND_USER: buildEndpoint('calendars/workers/:id/find-user'),
        GET_WORKER_CALENDAR: buildEndpoint('calendars/workers/:id/calendar'),
        FINANCIAL_SUMMARY_PERMISSION: buildEndpoint('calendars/workers/has-financial-summary-permission')
    },
    WORKER_DOCUMENTS: {
        HISTORY_BY_WORKER_AND_TYPE: buildEndpoint(
            'calendars/worker-documents/:worker_id/:document_id/history'
        ),
        GET_WORKER_DOCUMENTS_BY_WORKER: buildEndpoint('calendars/worker-documents/:id/by-worker'),
        STORE_WORKER_DOCUMENT: buildEndpoint('calendars/worker-documents/store'),
        GET_BY_SET: buildEndpoint('calendars/worker-documents/:worker_id/get-by-set'),
        EDIT_WORKER_DOCUMENT: buildEndpoint('calendars/worker-documents/:worker_id/:document_id/edit'),
        UPDATE_WORKER_DOCUMENT: buildEndpoint('calendars/worker-documents/:worker_document_id/update'),
        DELETE_WORKER_DOCUMENT: buildEndpoint('calendars/worker-documents/:worker_id/:document_id/delete'),
    },
    SHIFTS: {
        GET_SHIFTS: buildEndpoint('calendars/shifts'),
        STORE_SHIFTS: buildEndpoint('calendars/shifts/store'),
        CREATE_SHIFT: buildEndpoint('calendars/shifts/create'),
        DELETE_SHIFT: buildEndpoint('calendars/shifts/:id/delete'),
        DELETE_NEXT_SHIFT: buildEndpoint('calendars/shifts/:id/delete-next'),
        DELETE_ONE_SHIFT: buildEndpoint('calendars/shifts/:id/delete-one'),
        EDIT_SHIFT: buildEndpoint('calendars/shifts/:id/edit'),
        UPDATE_SHIFT: buildEndpoint('calendars/shifts/:id/update'),
        ACTIVE_SHIFT: buildEndpoint('calendars/shifts/:id/active'),
        GET_SHIFT_BY_DATE: buildEndpoint('calendars/shifts/by-date')
    },
    TRAVEL_EXPENSES: {
        GET_TRAVEL_EXPENSES: buildEndpoint('calendars/travel-expenses'),
        STORE_TRAVEL_EXPENSES: buildEndpoint('calendars/travel-expenses/store'),
        CREATE_TRAVEL_EXPENSES: buildEndpoint('calendars/travel-expenses/create'),
        DELETE_TRAVEL_EXPENSES: buildEndpoint('calendars/travel-expenses/:id/delete'),
        EDIT_TRAVEL_EXPENSES: buildEndpoint('calendars/travel-expenses/:id/edit'),
        UPDATE_TRAVEL_EXPENSES: buildEndpoint('calendars/travel-expenses/:id/update'),
        ACTIVE_TRAVEL_EXPENSES: buildEndpoint('calendars/travel-expenses/:id/active')
    },
    JOB_TITLES: {
        GET_JOB_TITLES: buildEndpoint('calendars/job-titles'),
        STORE_JOB_TITLES: buildEndpoint('calendars/job-titles/store'),
        CREATE_JOB_TITLES: buildEndpoint('calendars/job-titles/create'),
        DELETE_JOB_TITLES: buildEndpoint('calendars/job-titles/:id/delete'),
        EDIT_JOB_TITLES: buildEndpoint('calendars/job-titles/:id/edit'),
        UPDATE_JOB_TITLES: buildEndpoint('calendars/job-titles/:id/update'),
        ACTIVE_JOB_TITLES: buildEndpoint('calendars/job-titles/:id/active')
    },
    JOB_TITLE_LIQUIDATION_SETS: {
        GET_JOB_TITLE_LIQUIDATION_SETS: buildEndpoint('calendars/job-title-liquidation-sets'),
        STORE_JOB_TITLE_LIQUIDATION_SETS: buildEndpoint(
            'calendars/job-title-liquidation-sets/store'
        ),
        CREATE_JOB_TITLE_LIQUIDATION_SETS: buildEndpoint(
            'calendars/job-title-liquidation-sets/create'
        ),
        DELETE_JOB_TITLE_LIQUIDATION_SETS: buildEndpoint(
            'calendars/job-title-liquidation-sets/:id/delete'
        ),
        EDIT_JOB_TITLE_LIQUIDATION_SETS: buildEndpoint(
            'calendars/job-title-liquidation-sets/:id/edit'
        ),
        UPDATE_JOB_TITLE_LIQUIDATION_SETS: buildEndpoint(
            'calendars/job-title-liquidation-sets/:id/update'
        ),
        ACTIVE_JOB_TITLE_LIQUIDATION_SETS: buildEndpoint(
            'calendars/job-title-liquidation-sets/:id/active'
        )
    },
    STATUS_HISTORIES: {
        GET_STATUS_HISTORIES: buildEndpoint('status-histories/status-histories'),
        GET_STATUS_HISTORY_CODES: buildEndpoint('status-histories/status-histories/all-codes')
    },
    COLUMNS: {
        GET_COLUMNS_BY_TABLE: buildEndpoint('columns/by-table/:table-name'),
        GET_COLUMNS_BY_TABLE_AND_ROLE: buildEndpoint('columns/by-table-and-role/:table-name/:rol-id'),
        CREATE_COLUMN_GROUP: buildEndpoint('columns/by-table/:table-name/create'),
        STORE_COLUMN_GROUP: buildEndpoint('columns/column-group/store'),
        GET_COLUMNS_BY_TABLE_AND_USER: buildEndpoint('columns/user-column-set/by-table-and-user/:table-name/:user-id'),
        CREATE_USER_COLUMN_SET: buildEndpoint('columns/user-column-set/:table-name/create'),
        STORE_USER_COLUMN_SET: buildEndpoint('columns/user-column-set/store'),
        EDIT_COLUMN_SET_BY_TABLE_AND_USER: buildEndpoint('columns/column-set/:table-name/edit'),
        STORE_COLUMN_SET: buildEndpoint('columns/column-set/store')
    },
    SURVEYS: {
        GET_SURVEYS: buildEndpoint('checklists/surveys'),
        CREATE_SURVEY: buildEndpoint('checklists/surveys/create'),
        STORE_SURVEY: buildEndpoint('checklists/surveys/store'),
        EDIT_SURVEY: buildEndpoint('checklists/surveys/:id/edit'),
        SHOW_SURVEY: buildEndpoint('checklists/surveys/:id/show'),
        UPDATE_SURVEY: buildEndpoint('checklists/surveys/:id/update'),
        GET_SURVEY: buildEndpoint('checklists/surveys/:id/get'),
        GET_SURVEY_BY_EVENT_TYPE: buildEndpoint('checklists/surveys/:event_type_id/get_by_event_type'),
        DELETE_SURVEY: buildEndpoint('checklists/surveys/:id/delete'),
        ACTIVE_SURVEY: buildEndpoint('checklists/surveys/:id/active')
    },
    SECTIONS: {
        GET_SECTIONS: buildEndpoint('checklists/sections'),
        GET_SECTIONS_BY_SURVEY: buildEndpoint('checklists/sections/:survey_id/by-survey'),
        CREATE_SECTION: buildEndpoint('checklists/sections/create'),
        STORE_SECTION: buildEndpoint('checklists/sections/store'),
        EDIT_SECTION: buildEndpoint('checklists/sections/:id/edit'),
        SHOW_SECTION: buildEndpoint('checklists/sections/:id/show'),
        UPDATE_SECTION: buildEndpoint('checklists/sections/:id/update'),
        GET_SECTION: buildEndpoint('checklists/sections/:id/get'),
        DELETE_SECTION: buildEndpoint('checklists/sections/:id/delete'),
        ACTIVE_SECTION: buildEndpoint('checklists/sections/:id/active'),
        GET_NEXT_SECTIONS_BY_SURVEY: buildEndpoint('checklists/sections/:section_id/:survey_id/next-by-survey'),
    },
    QUESTIONS: {
        GET_QUESTIONS: buildEndpoint('checklists/questions'),
        GET_QUESTIONS_BY_SECTION: buildEndpoint('checklists/questions/:section_id/by-section'),
        CREATE_QUESTION: buildEndpoint('checklists/questions/:section_id/create'),
        STORE_QUESTION: buildEndpoint('checklists/questions/store'),
        EDIT_QUESTION: buildEndpoint('checklists/questions/:id/edit'),
        SHOW_QUESTION: buildEndpoint('checklists/questions/:id/show'),
        UPDATE_QUESTION: buildEndpoint('checklists/questions/:id/update'),
        GET_QUESTION: buildEndpoint('checklists/questions/:id/get'),
        DELETE_QUESTION: buildEndpoint('checklists/questions/:id/delete'),
        ACTIVE_QUESTION: buildEndpoint('checklists/questions/:id/active'),
        REQUIRED_QUESTION: buildEndpoint('checklists/questions/:id/required'),
        INCLUDE_IMAGE: buildEndpoint('checklists/questions/:id/include-image'),
        INCLUDE_COMMENT: buildEndpoint('checklists/questions/:id/include-comment')
    },
    RESPONSE_OPTIONS: {
        GET_RESPONSE_OPTIONS: buildEndpoint('checklists/response-options'),
        GET_RESPONSE_OPTIONS_BY_QUESTION: buildEndpoint('checklists/response-options/:question_id/by-question'),
        CREATE_RESPONSE_OPTION: buildEndpoint('checklists/response-options/create'),
        STORE_RESPONSE_OPTION: buildEndpoint('checklists/response-options/store'),
        EDIT_RESPONSE_OPTION: buildEndpoint('checklists/response-options/:id/edit'),
        SHOW_RESPONSE_OPTION: buildEndpoint('checklists/response-options/:id/show'),
        UPDATE_RESPONSE_OPTION: buildEndpoint('checklists/response-options/:id/update'),
        GET_RESPONSE_OPTION: buildEndpoint('checklists/response-options/:id/get'),
        DELETE_RESPONSE_OPTION: buildEndpoint('checklists/response-options/:id/delete'),
        ACTIVE_RESPONSE_OPTION: buildEndpoint('checklists/response-options/:id/active')
    },
    USER_RESPONSES: {
        GET_USER_RESPONSES: buildEndpoint('checklists/user-responses'),
        GET_USER_RESPONSES_BY_SURVEY: buildEndpoint('checklists/user-responses/:survey_id/by-survey'),
        GET_IN_PROGRESS_USER_RESPONSES_BY_SURVEY: buildEndpoint('checklists/user-responses/in-progress-user-responses/:survey_id/:calendar_date/by-survey'),
        GET_USER_RESPONSE_BY_DATE_AND_WORKER: buildEndpoint('checklists/user-responses/all/:worker_id/:calendar_date/by-worker-and-date'),
        GET_IN_PROGRESS_USER_RESPONSE_BY_ID: buildEndpoint('checklists/user-responses/in-progress-user-responses/:response_id/by-id'),
        CREATE_USER_RESPONSE: buildEndpoint('checklists/user-responses/create'),
        STORE_USER_RESPONSE: buildEndpoint('checklists/user-responses/store'),
        STORE_USER_FILES: buildEndpoint('checklists/user-responses/store-files'),
        EDIT_USER_RESPONSE: buildEndpoint('checklists/user-responses/:id/edit'),
        SHOW_USER_RESPONSE: buildEndpoint('checklists/user-responses/:id/show'),
        UPDATE_USER_RESPONSE: buildEndpoint('checklists/user-responses/:id/update'),
        GET_USER_RESPONSE: buildEndpoint('checklists/user-responses/:id/get'),
        DELETE_USER_RESPONSE: buildEndpoint('checklists/user-responses/:id/delete'),
        ACTIVE_USER_RESPONSE: buildEndpoint('checklists/user-responses/:id/active')
    },
    USER_RESPONSE_DETAILS: {
        GET_USER_RESPONSE_DETAILS: buildEndpoint('checklists/user-response-details'),
        GET_USER_RESPONSE_DETAILS_BY_USER_RESPONSE: buildEndpoint('checklists/user-response-details/:user_response_id/by-user-response'),
        CREATE_USER_RESPONSE_DETAIL: buildEndpoint('checklists/user-response-details/create'),
        STORE_USER_RESPONSE_DETAIL: buildEndpoint('checklists/user-response-details/store'),
        EDIT_USER_RESPONSE_DETAIL: buildEndpoint('checklists/user-response-details/:id/edit'),
        SHOW_USER_RESPONSE_DETAIL: buildEndpoint('checklists/user-response-details/:id/show'),
        UPDATE_USER_RESPONSE_DETAIL: buildEndpoint('checklists/user-response-details/:id/update'),
        GET_USER_RESPONSE_DETAIL: buildEndpoint('checklists/user-response-details/:id/get'),
        DELETE_USER_RESPONSE_DETAIL: buildEndpoint('checklists/user-response-details/:id/delete')
    },
    USER_RESPONSE_OPTIONS: {
        GET_USER_RESPONSE_OPTIONS: buildEndpoint('checklists/user-response-options'),
        GET_USER_RESPONSE_OPTIONS_BY_USER_RESPONSE_DETAIL: buildEndpoint('checklists/user-response-options/:user_response_detail_id/by-user-response-detail'),
        CREATE_USER_RESPONSE_OPTION: buildEndpoint('checklists/user-response-options/create'),
        STORE_USER_RESPONSE_OPTION: buildEndpoint('checklists/user-response-options/store'),
        EDIT_USER_RESPONSE_OPTION: buildEndpoint('checklists/user-response-options/:id/edit'),
        SHOW_USER_RESPONSE_OPTION: buildEndpoint('checklists/user-response-options/:id/show'),
        UPDATE_USER_RESPONSE_OPTION: buildEndpoint('checklists/user-response-options/:id/update'),
        GET_USER_RESPONSE_OPTION: buildEndpoint('checklists/user-response-options/:id/get'),
        DELETE_USER_RESPONSE_OPTION: buildEndpoint('checklists/user-response-options/:id/delete')
    },
    USER_RESPONSE_FILES: {
        GET_USER_RESPONSE_FILES: buildEndpoint('checklists/user-response-files'),
        GET_USER_RESPONSE_FILES_BY_USER_RESPONSE_DETAIL: buildEndpoint('checklists/user-response-files/:user_response_detail_id/by-user-respomse-detail'),
        CREATE_USER_RESPONSE_FILE: buildEndpoint('checklists/user-response-files/create'),
        STORE_USER_RESPONSE_FILE: buildEndpoint('checklists/user-response-files/store'),
        EDIT_USER_RESPONSE_FILE: buildEndpoint('checklists/user-response-files/:id/edit'),
        SHOW_USER_RESPONSE_FILE: buildEndpoint('checklists/user-response-files/:id/show'),
        UPDATE_USER_RESPONSE_FILE: buildEndpoint('checklists/user-response-files/:id/update'),
        GET_USER_RESPONSE_FILE: buildEndpoint('checklists/user-response-files/:id/get'),
        DELETE_USER_RESPONSE_FILE: buildEndpoint('checklists/user-response-files/:id/delete')
    },
    AI_TOLLS: {
        COUNT_PENDING_TOLL_EXPENSES: buildEndpoint('ai-tolls/count-pending-tolls'),
        PENDING_TOLL_EXPENSES: buildEndpoint('ai-tolls/pending-toll-expenses'),
        ALL_PENDING_TOLLS: buildEndpoint('ai-tolls/all-pending-tolls')
    },


    //
    // New endpoints added
    //


    BATCHES: {
        GET_BATCHES: buildEndpoint('batches/batches'),
        GET_EXCEL_BATCHES: buildEndpoint('batches/batches/excel'),
        CREATE_BATCH: buildEndpoint('batches/batches/create'),
        STORE_BATCH: buildEndpoint('batches/batches/store'),
        EDIT_BATCH: buildEndpoint('batches/batches/:id/edit'),
        UPDATE_BATCH: buildEndpoint('batches/batches/:id/update'),
        DELETE_BATCH: buildEndpoint('batches/batches/:id/delete'),
        ACTIVE_BATCH: buildEndpoint('batches/batches/:id/active'),
        BARCODE_BATCH: buildEndpoint('batches/batches/:id/barcode'),
        CLONE_BATCH: buildEndpoint('batches/batches/:id/clone')
    },

    CENTERS: {
        GET_CENTERS: buildEndpoint('centers/centers'),
        CREATE_CENTER: buildEndpoint('centers/centers/create'),
        STORE_CENTER: buildEndpoint('centers/centers/store'),
        EDIT_CENTER: buildEndpoint('centers/centers/:id/edit'),
        UPDATE_CENTER: buildEndpoint('centers/centers/:id/update'),
        DELETE_CENTER: buildEndpoint('centers/centers/:id/delete'),
        ACTIVE_CENTER: buildEndpoint('centers/centers/:id/active')
    },

    WAREHOUSES: {
        GET_WAREHOUSES: buildEndpoint('warehouses/warehouses'),
        CREATE_WAREHOUSE: buildEndpoint('warehouses/warehouses/create'),
        STORE_WAREHOUSE: buildEndpoint('warehouses/warehouses/store'),
        EDIT_WAREHOUSE: buildEndpoint('warehouses/warehouses/:id/edit'),
        UPDATE_WAREHOUSE: buildEndpoint('warehouses/warehouses/:id/update'),
        DELETE_WAREHOUSE: buildEndpoint('warehouses/warehouses/:id/delete'),
        ACTIVE_WAREHOUSE: buildEndpoint('warehouses/warehouses/:id/active')
    },

    PROJECTS: {
        GET_PROJECTS: buildEndpoint('projects/projects'),
        CREATE_PROJECT: buildEndpoint('projects/projects/create'),
        STORE_PROJECT: buildEndpoint('projects/projects/store'),
        EDIT_PROJECT: buildEndpoint('projects/projects/:id/edit'),
        UPDATE_PROJECT: buildEndpoint('projects/projects/:id/update'),
        DELETE_PROJECT: buildEndpoint('projects/projects/:id/delete'),
        ACTIVE_PROJECT: buildEndpoint('projects/projects/:id/active'),
        CHANGE_STATUS_PROJECT: buildEndpoint('projects/projects/:id/change-status')
    },

    PACKING_ORDERS: {
        GET_PACKING_ORDERS: buildEndpoint('packing-orders/packing-orders'),
        CREATE_PACKING_ORDER: buildEndpoint('packing-orders/packing-orders/create'),
        STORE_PACKING_ORDER: buildEndpoint('packing-orders/packing-orders/store'),
        EDIT_PACKING_ORDER: buildEndpoint('packing-orders/packing-orders/:id/edit'),
        UPDATE_PACKING_ORDER: buildEndpoint('packing-orders/packing-orders/:id/update'),
        DELETE_PACKING_ORDER: buildEndpoint('packing-orders/packing-orders/:id/delete'),
        ACTIVE_PACKING_ORDER: buildEndpoint('packing-orders/packing-orders/:id/active'),
        GET_OUTPUT_PRODUCTS: buildEndpoint('packing-orders/packing-orders/:packing_order_id/output-products'),
        STORE_OUTPUT_PRODUCT: buildEndpoint('packing-orders/packing-orders/output-products/store'),
        UPDATE_OUTPUT_PRODUCT: buildEndpoint('packing-orders/packing-orders/output-products/:id/update'),
        DELETE_OUTPUT_PRODUCT: buildEndpoint('packing-orders/packing-orders/output-products/:id/delete'),
        GET_INPUT_PRODUCTS: buildEndpoint('packing-orders/packing-orders/:packing_order_id/input-products'),
        STORE_INPUT_PRODUCT: buildEndpoint('packing-orders/packing-orders/input-products/store'),
        UPDATE_INPUT_PRODUCT: buildEndpoint('packing-orders/packing-orders/input-products/:id/update'),
        DELETE_INPUT_PRODUCT: buildEndpoint('packing-orders/packing-orders/input-products/:id/delete'),
        GET_ORDER_INCIDENTS: buildEndpoint('packing-orders/packing-orders/:id/incidents'),
        STORE_ORDER_INCIDENT: buildEndpoint('packing-orders/packing-orders/:id/incidents/store'),
        UPDATE_ORDER_INCIDENT: buildEndpoint('packing-orders/packing-orders/incidents/:incident_id/update'),
        DELETE_ORDER_INCIDENT: buildEndpoint('packing-orders/packing-orders/incidents/:incident_id/delete'),
        GET_REQUIRED_STOCK: buildEndpoint('packing-orders/packing-orders/:packing_order_id/required-stock'),
        GET_EMPACAR_DATA: buildEndpoint('packing-orders/packing-orders/:packing_order_id/empacar-data'),
        POST_EMPACAR: buildEndpoint('packing-orders/packing-orders/:packing_order_id/empacar'),
        GET_PRODUCED_BATCHES: buildEndpoint('packing-orders/packing-orders/:packing_order_id/produced-batches'),
        GET_RECIPE_REQUIREMENTS: buildEndpoint('packing-orders/packing-orders/output-products/:output_product_id/recipe-requirements'),
    },

    COLLECTION_ORDERS: {
        GET_COLLECTION_ORDERS: buildEndpoint('collection-orders/collection-orders'),
        CREATE_COLLECTION_ORDER: buildEndpoint('collection-orders/collection-orders/create'),
        STORE_COLLECTION_ORDER: buildEndpoint('collection-orders/collection-orders/store'),
        EDIT_COLLECTION_ORDER: buildEndpoint('collection-orders/collection-orders/:id/edit'),
        UPDATE_COLLECTION_ORDER: buildEndpoint('collection-orders/collection-orders/:id/update'),
        DELETE_COLLECTION_ORDER: buildEndpoint('collection-orders/collection-orders/:id/delete'),
        ACTIVE_COLLECTION_ORDER: buildEndpoint('collection-orders/collection-orders/:id/active'),
        SHOW_COLLECTION_ORDER: buildEndpoint('collection-orders/collection-orders/:id/show'),
        HISTORY_COLLECTION_ORDER: buildEndpoint('collection-orders/collection-orders/:id/history'),
    },

    COLLECTION_ORDER_BATCHES: {
        GET_COLLECTION_ORDER_BATCHES: buildEndpoint('collection-orders/collection-orders/:id/batches'),
        CREATE_COLLECTION_ORDER_BATCH: buildEndpoint('collection-orders/collection-orders/:id/batches/create'),
        STORE_COLLECTION_ORDER_BATCH: buildEndpoint('collection-orders/collection-orders/:id/batches/store'),
        DELETE_COLLECTION_ORDER_BATCH: buildEndpoint('collection-orders/collection-orders/batches/:link_id/delete'),
        STORE_COLLECTION_ORDER_BATCH_BY_BARCODE: buildEndpoint('collection-orders/collection-orders/:id/batches/barcode'),
        UPDATE_BATCH_STATUS: buildEndpoint('collection-orders/collection-orders/batches/:link_id/status'),
    },

    COLLECTION_ORDER_COLLECTORS: {
        GET_COLLECTION_ORDER_COLLECTORS: buildEndpoint('collection-orders/collection-orders/:id/collectors'),
        CREATE_COLLECTION_ORDER_COLLECTOR: buildEndpoint('collection-orders/collection-orders/:id/collectors/create'),
        STORE_COLLECTION_ORDER_COLLECTOR: buildEndpoint('collection-orders/collection-orders/:id/collectors/store'),
        DELETE_COLLECTION_ORDER_COLLECTOR: buildEndpoint('collection-orders/collection-orders/collectors/:link_id/delete'),
    },
    COLLECTION_ORDER_INCIDENTS: {
        GET_COLLECTION_ORDER_INCIDENTS: buildEndpoint('collection-orders/collection-orders/:id/incidents'),
        STORE_COLLECTION_ORDER_INCIDENT: buildEndpoint('collection-orders/collection-orders/:id/incidents/store'),
        UPDATE_COLLECTION_ORDER_INCIDENT: buildEndpoint('collection-orders/collection-orders/incidents/:incident_id/update'),
        DELETE_COLLECTION_ORDER_INCIDENT: buildEndpoint('collection-orders/collection-orders/incidents/:incident_id/delete'),
    },


    SELECTION_ORDERS: {
        GET_SELECTION_ORDERS: buildEndpoint('selection-orders/selection-orders'),
        CREATE_SELECTION_ORDER: buildEndpoint('selection-orders/selection-orders/create'),
        STORE_SELECTION_ORDER: buildEndpoint('selection-orders/selection-orders/store'),
        EDIT_SELECTION_ORDER: buildEndpoint('selection-orders/selection-orders/:id/edit'),
        UPDATE_SELECTION_ORDER: buildEndpoint('selection-orders/selection-orders/:id/update'),
        DELETE_SELECTION_ORDER: buildEndpoint('selection-orders/selection-orders/:id/delete'),
        ACTIVE_SELECTION_ORDER: buildEndpoint('selection-orders/selection-orders/:id/active'),
        SHOW_SELECTION_ORDER: buildEndpoint('selection-orders/selection-orders/:id/show'),
        HISTORY_SELECTION_ORDER: buildEndpoint('selection-orders/selection-orders/:id/history'),
    },

    SELECTION_ORDER_BATCHES: {
        GET_SELECTION_ORDER_BATCHES: buildEndpoint('selection-orders/selection-orders/:id/batches'),
        CREATE_SELECTION_ORDER_BATCH: buildEndpoint('selection-orders/selection-orders/:id/batches/create'),
        STORE_SELECTION_ORDER_BATCH: buildEndpoint('selection-orders/selection-orders/:id/batches/store'),
        DELETE_SELECTION_ORDER_BATCH: buildEndpoint('selection-orders/selection-orders/batches/:link_id/delete'),
        STORE_SELECTION_ORDER_BATCH_BY_BARCODE: buildEndpoint('selection-orders/selection-orders/:id/batches/barcode'),
        UPDATE_BATCH_STATUS: buildEndpoint('selection-orders/selection-orders/batches/:link_id/status'),
        
        CREATE_LOAD_BATCH: buildEndpoint('selection-orders/selection-orders/:id/batches/load/create'),
        STORE_LOAD_BATCH: buildEndpoint('selection-orders/selection-orders/:id/batches/load/store'),
    },

    SELECTION_ORDER_DESTINATION_BATCHES: {
        GET_DESTINATION_BATCHES: buildEndpoint('selection-orders/selection-orders/:id/destination-batches'),
        CREATE_DESTINATION_BATCH_OPTIONS: buildEndpoint('selection-orders/selection-orders/:id/destination-batches/create'),
        STORE_DESTINATION_BATCH: buildEndpoint('selection-orders/selection-orders/:id/destination-batches/store'),
        DELETE_DESTINATION_BATCH: buildEndpoint('selection-orders/selection-orders/destination-batches/:dest_id/delete'),
        VOID_DESTINATION_BATCH: buildEndpoint('selection-orders/selection-orders/destination-batches/:dest_id/void'),
    },

    SELECTION_ORDER_COLLECTORS: {
        GET_SELECTION_ORDER_COLLECTORS: buildEndpoint('selection-orders/selection-orders/:id/collectors'),
        CREATE_SELECTION_ORDER_COLLECTOR: buildEndpoint('selection-orders/selection-orders/:id/collectors/create'),
        STORE_SELECTION_ORDER_COLLECTOR: buildEndpoint('selection-orders/selection-orders/:id/collectors/store'),
        DELETE_SELECTION_ORDER_COLLECTOR: buildEndpoint('selection-orders/selection-orders/collectors/:link_id/delete'),
    },
    SELECTION_ORDER_INCIDENTS: {
        GET_SELECTION_ORDER_INCIDENTS: buildEndpoint('selection-orders/selection-orders/:id/incidents'),
        STORE_SELECTION_ORDER_INCIDENT: buildEndpoint('selection-orders/selection-orders/:id/incidents/store'),
        UPDATE_SELECTION_ORDER_INCIDENT: buildEndpoint('selection-orders/selection-orders/incidents/:incident_id/update'),
        DELETE_SELECTION_ORDER_INCIDENT: buildEndpoint('selection-orders/selection-orders/incidents/:incident_id/delete'),
    },

    PURCHASE_ORDER : {
        GET_PURCHASE_ORDERS: buildEndpoint('purchase-orders/purchase-orders'),
        CREATE_PURCHASE_ORDER: buildEndpoint('purchase-orders/purchase-orders/create'),
        STORE_PURCHASE_ORDER: buildEndpoint('purchase-orders/purchase-orders/store'),
        EDIT_PURCHASE_ORDER: buildEndpoint('purchase-orders/purchase-orders/:id/edit'),
        SHOW_PURCHASE_ORDER: buildEndpoint('purchase-orders/purchase-orders/:id/show'),
        UPDATE_PURCHASE_ORDER: buildEndpoint('purchase-orders/purchase-orders/:id/update'),
        UPDATE_PURCHASE_ORDER_INVOICING: buildEndpoint('purchase-orders/purchase-orders/:id/update-invoicing'),

        DELETE_PURCHASE_ORDER: buildEndpoint('purchase-orders/purchase-orders/:id/delete'),
        HAS_ALL_FINISHED_STATUSES: buildEndpoint(
            'purchase-orders/purchase-orders/:id/:purchase_order_status/has-finished'
        ),
        CHANGE_STATUS_PURCHASE_ORDER: buildEndpoint('purchase-orders/purchase-orders/:id/change-status'),
        CHANGE_STATUS_TO_CONFIRMED_PURCHASE_ORDER: buildEndpoint('purchase-orders/purchase-orders/:id/change-status-to-confirmed'),
        CHANGE_STATUS_TO_ANNULLED_PURCHASE_ORDER: buildEndpoint('purchase-orders/purchase-orders/:id/change-status-to-annulled'),
        CHANGE_STATUS_TO_PENDING_PURCHASE_ORDER: buildEndpoint('purchase-orders/purchase-orders/:id/change-status-to-pending'),
        OVERRIDE_CONFIRMED_PURCHASE_ORDER: buildEndpoint('purchase-orders/purchase-orders/:id/override-confirmed'),
        HAS_ALL_CONFIRMED_BY_PURCHASE_ORDER: buildEndpoint('purchase-orders/purchase-orders/:purchase_order_id/has-all-confirmed'),
        GET_PURCHASE_ORDERS_BY_SOCIETY_AND_PROVIDER: buildEndpoint('purchase-orders/purchase-orders/:society_id/:provider_id/:id/get-purchase-orders'),
    },
    PURCHASE_ORDER_DETAIL : {
        GET_PURCHASE_ORDER_DETAILS_BY_PURCHASE_ORDER: buildEndpoint('purchase-orders/purchase-order-details/:purchase_order_id/by-purchase-order'),
        GET_PURCHASE_ORDER_DETAILS_FINISHED: buildEndpoint('purchase-orders/purchase-order-details/:dispatch_program_id/:interlocutor_id/finished'),
        STORE_PURCHASE_ORDER_DETAIL: buildEndpoint('purchase-orders/purchase-order-details/store'),
        CREATE_PURCHASE_ORDER_DETAIL: buildEndpoint('purchase-orders/purchase-order-details/:item_type/create'),
        EDIT_PURCHASE_ORDER_DETAIL: buildEndpoint('purchase-orders/purchase-order-details/:id/edit'),
        SHOW_PURCHASE_ORDER_DETAIL: buildEndpoint('purchase-orders/purchase-order-details/:id/show'),
        GET_PURCHASE_ORDER_DETAIL: buildEndpoint('purchase-orders/purchase-order-details/:id/:service_manifest_detail_id/get'),
        UPDATE_PURCHASE_ORDER_DETAIL: buildEndpoint('purchase-orders/purchase-order-details/:id/update'),
        DELETE_PURCHASE_ORDER_DETAIL: buildEndpoint('purchase-orders/purchase-order-details/:id/delete'),
    },
    INCOTERMS: {
        GET_INCOTERMS: buildEndpoint('purchase-orders/incoterms'),
        STORE_INCOTERM: buildEndpoint('purchase-orders/incoterms/store'),
        CREATE_INCOTERM: buildEndpoint('purchase-orders/incoterms/create'),
        EDIT_INCOTERM: buildEndpoint('purchase-orders/incoterms/:id/edit'),
        UPDATE_INCOTERM: buildEndpoint('purchase-orders/incoterms/:id/update'),
        DELETE_INCOTERM: buildEndpoint('purchase-orders/incoterms/:id/delete'),
        ACTIVE_INCOTERM: buildEndpoint('purchase-orders/incoterms/:id/active'),
    },

    SERVICE_MANIFEST: {
        GET_SERVICE_MANIFESTS: buildEndpoint('service-manifests/service-manifests'),
        CREATE_SERVICE_MANIFEST: buildEndpoint('service-manifests/service-manifests/create'),
        STORE_SERVICE_MANIFEST: buildEndpoint('service-manifests/service-manifests/store'),
        EDIT_SERVICE_MANIFEST: buildEndpoint('service-manifests/service-manifests/:id/edit'),
        SHOW_SERVICE_MANIFEST: buildEndpoint('service-manifests/service-manifests/:id/show'),
        UPDATE_SERVICE_MANIFEST: buildEndpoint('service-manifests/service-manifests/:id/update'),
        UPDATE_SERVICE_MANIFEST_INVOICING: buildEndpoint('service-manifests/service-manifests/:id/update-invoicing'),
        DELETE_SERVICE_MANIFEST: buildEndpoint('service-manifests/service-manifests/:id/delete'),
        GET_SERVICE_MANIFESTS_BY_PROVIDER_SOCIETY: buildEndpoint('service-manifests/service-manifests/by-society-provider/:society_id/:provider_id'),
        HAS_ALL_FINISHED_STATUSES: buildEndpoint(
            'service-manifests/service-manifests/:id/:service_manifest_status/has-finished'
        ),
        CHANGE_STATUS_SERVICE_MANIFEST: buildEndpoint(
            'service-manifests/service-manifests/:id/change-status'
        ),
        
        STORE_SERVICE_MANIFEST_ON_DISPATCH_PROGRAM: buildEndpoint('service-manifests/service-manifests/store-on-dp'),
        GO_SERVICE_MANIFEST: buildEndpoint('service-manifests/service-manifests/:interlocutor_id/go-service-manifest'),
        GET_EXCELL_SERVICE_MANIFEST: buildEndpoint('service-manifests/service-manifests/excel'),
    },
    INTERLOCUTOR_SERVICE_MANIFEST: {

        GET_INTERLOCUTOR_SERVICE_MANIFEST:  buildEndpoint('interlocutors/interlocutor-service-manifest/:dispatch_program_id/by-dispatch-program'),
        DELETE_SERVICE_MANIFEST_BY_DISPATCH_PROGRAM: buildEndpoint('interlocutors/interlocutor-service-manifest/:id/delete'),

    },
    SERVICE_MANIFEST_DOCUMENT: {
        GET_SERVICE_MANIFEST_DOCUMENTS_BY_SERVICE_MANIFEST: buildEndpoint(
            'service-manifests/service-manifest-documents/:service_manifest_id/by-service-manifest'
        ),
        CREATE_SERVICE_MANIFEST_DOCUMENT: buildEndpoint(
            'service-manifests/service-manifest-documents/create'
        ),
        STORE_SERVICE_MANIFEST_DOCUMENT: buildEndpoint(
            'service-manifests/service-manifest-documents/store'
        ),
        EDIT_SERVICE_MANIFEST_DOCUMENT: buildEndpoint(
            'service-manifests/service-manifest-documents/:id/edit'
        ),
        SHOW_SERVICE_MANIFEST_DOCUMENT: buildEndpoint(
            'service-manifests/service-manifest-documents/:id/show'
        ),
        UPDATE_SERVICE_MANIFEST_DOCUMENT: buildEndpoint(
            'service-manifests/service-manifest-documents/:id/update'
        ),
        DELETE_SERVICE_MANIFEST_DOCUMENT: buildEndpoint(
            'service-manifests/service-manifest-documents/:id/delete'
        )
    },
    SERVICE_MANIFEST_DETAIL: {
        GET_SERVICE_MANIFEST_DETAILS_BY_SERVICE_MANIFEST: buildEndpoint(
            'service-manifests/service-manifest-details/:service_manifest_id/by-service-manifest'
        ),
        STORE_SERVICE_MANIFEST_DETAIL: buildEndpoint(
            'service-manifests/service-manifest-details/store'
        ),
        CREATE_SERVICE_MANIFEST_DETAIL: buildEndpoint(
            'service-manifests/service-manifest-details/:service_manifest_id/create'
        ),
        EDIT_SERVICE_MANIFEST_DETAIL: buildEndpoint(
            'service-manifests/service-manifest-details/:id/edit'
        ),
        SHOW_SERVICE_MANIFEST_DETAIL: buildEndpoint(
            'service-manifests/service-manifest-details/:id/show'
        ),
        UPDATE_SERVICE_MANIFEST_DETAIL: buildEndpoint(
            'service-manifests/service-manifest-details/:id/update'
        ),
        DELETE_SERVICE_MANIFEST_DETAIL: buildEndpoint(
            'service-manifests/service-manifest-details/:id/delete'
        ),
        HAS_ALL_FINISHED_STATUSES: buildEndpoint(
            'service-manifests/service-manifest-details/:id/:service_manifest_detail_status/has-finished'
        ),
        CHANGE_STATUS_SERVICE_MANIFEST_DETAIL: buildEndpoint(
            'service-manifests/service-manifest-details/:id/change-status'
        )
    },

    PURCHASE_DOCUMENT: {
        GET_PURCHASE_DOCUMENT: buildEndpoint('purchase-documents/purchase-documents'),
        EDIT_PURCHASE_DOCUMENT: buildEndpoint('purchase-documents/purchase-documents/:id/edit'),
        SHOW_PURCHASE_DOCUMENT: buildEndpoint('purchase-documents/purchase-documents/:id/show'),
        DELETE_PURCHASE_DOCUMENT: buildEndpoint('purchase-documents/purchase-documents/:id/delete'),
        ACCOUNTED: buildEndpoint('purchase-documents/purchase-documents/:id/change-to-accounted'),
        // ANNULLED: buildEndpoint('tax-documents/tax-documents/:id/change-to-annulled'),
        // DRAFT: buildEndpoint('tax-documents/tax-documents/:id/change-to-draft'),
        ACTIVE_PURCHASE_DOCUMENT: buildEndpoint('purchase-documents/purchase-documents/:id/active'),

        //Purchase Invoice
        CREATE_PURCHASE_INVOICE: buildEndpoint('purchase-documents/purchase-documents/purchase-invoice/create'),
        STORE_PURCHASE_INVOICE: buildEndpoint('purchase-documents/purchase-documents/purchase-invoice/store'),
        UPDATE_PURCHASE_INVOICE: buildEndpoint('purchase-documents/purchase-documents/purchase-invoice/:id/update'),

        //Note
        // CREATE_NOTE: buildEndpoint('tax-documents/tax-documents/note/create'),
        // GET_CAUSE_NOTE: buildEndpoint('tax-documents/tax-documents/note/:note_type>/cause-note-by-note-type'),
        // STORE_NOTE: buildEndpoint('tax-documents/tax-documents/note/store'),
        // UPDATE_NOTE: buildEndpoint('tax-documents/tax-documents/note/:id/update'),
        // CALCULATE_TOTAL_NOTE: buildEndpoint('tax-documents/tax-documents/note/calculate-total'),
    },

    PURCHASE_DOCUMENT_DETAIL: {
        GET_PURCHASE_DOCUMENT_DETAILS_BY_PURCHASE_DOCUMENT: buildEndpoint('purchase-documents/purchase-document-detail/:id/by-purchase-document'),
        DELETE_PURCHASE_DOCUMENT_BY_PURCHASE_DOCUMENT: buildEndpoint('purchase-documents/purchase-document-detail/:id/delete/:payment_status_id'),
        GET_PURCHASE_DOCUMENT_DETAILS: buildEndpoint('purchase-documents/purchase-document-detail/:id/details'),
    },

    PURCHASE_DOCUMENT_HISTORY: {
        GET_PURCHASE_DOCUMENT_HISTORIES_BY_PURCHASE_DOCUMENT: buildEndpoint('purchase-documents/purchase-document-history/:purchase_document_id'),
    },

    SERVICE: {
        GET_SERVICES: buildEndpoint('services/services/'),
        STORE_SERVICE: buildEndpoint('services/services/store'),
        EDIT_SERVICE: buildEndpoint('services/services/:id/edit'),
        CREATE_SERVICE: buildEndpoint('services/services/create'),
        SHOW_SERVICE: buildEndpoint('services/services/:id/show'),
        UPDATE_SERVICE: buildEndpoint('services/services/:id/update'),
        DELETE_SERVICE: buildEndpoint('services/services/:id/delete'),
        ACTIVE_SERVICE: buildEndpoint('services/services/:id/active'),
        GET_SERVICE: buildEndpoint('services/services/:id/get'),
        GET_SERVICE_WITH_PURCHASE_ORDER: buildEndpoint('services/services/:id/:purchase_order_id/with-purchase-order'),
    },

    COST_CENTER: {
        GET_COST_CENTERS: buildEndpoint('cost-centers/cost-centers'),
        CREATE_COST_CENTER: buildEndpoint('cost-centers/cost-centers/create'),
        STORE_COST_CENTER: buildEndpoint('cost-centers/cost-centers/store'),
        EDIT_COST_CENTER: buildEndpoint('cost-centers/cost-centers/:id/edit'),
        SHOW_COST_CENTER: buildEndpoint('cost-centers/cost-centers/:id/show'),
        UPDATE_COST_CENTER: buildEndpoint('cost-centers/cost-centers/:id/update'),
        DELETE_COST_CENTER: buildEndpoint('cost-centers/cost-centers/:id/delete'),
        ACTIVE_COST_CENTER: buildEndpoint('cost-centers/cost-centers/:id/active')
    },

    COUNTRY: {
        GET_COUNTRIES: buildEndpoint('countries/countries'),
        STORE_COUNTRY: buildEndpoint('countries/countries/store'),
        EDIT_COUNTRY: buildEndpoint('countries/countries/:id/edit'),
        UPDATE_COUNTRY: buildEndpoint('countries/countries/:id/update'),
        DELETE_COUNTRY: buildEndpoint('countries/countries/:id/delete'),
        ACTIVE_COUNTRY: buildEndpoint('countries/countries/:id/active')
    },

    ACCOUNTING: {
        GET_ACCOUNTINGS_BY_SERVICE_MANIFEST_DETAIL: buildEndpoint(
            'accounts/accountings/:service_manifest_detail_id/by-service-manifest-detail'
        ),
        STORE_ACCOUNTING: buildEndpoint('accounts/accountings/store'),
        EDIT_ACCOUNTING: buildEndpoint('accounts/accountings/:id/edit'),
        SHOW_ACCOUNTING: buildEndpoint('accounts/accountings/:id/show'),
        UPDATE_ACCOUNTING: buildEndpoint('accounts/accountings/:id/update'),
        DELETE_ACCOUNTING: buildEndpoint('accounts/accountings/:id/delete')
    },

    INTERLOCUTOR: {
        GET_INTERLOCUTORS: buildEndpoint('interlocutors/interlocutors'),
        GET_INTERLOCUTORS_BY_DISPATCH_PROGRAM: buildEndpoint(
            'interlocutors/interlocutors/:dispatch_program_id/by-dispatch-program'
        ),
        STORE_INTERLOCUTOR: buildEndpoint('interlocutors/interlocutors/:id/store'),
        EDIT_INTERLOCUTOR: buildEndpoint('interlocutors/interlocutors/:id/edit'),
        CREATE_INTERLOCUTOR: buildEndpoint('interlocutors/interlocutors/:id/create'),
        SHOW_INTERLOCUTOR: buildEndpoint('interlocutors/interlocutors/:id/show'),
        UPDATE_INTERLOCUTOR: buildEndpoint('interlocutors/interlocutors/:id/update'),
        DELETE_INTERLOCUTOR: buildEndpoint('interlocutors/interlocutors/:dispatch_program_id/:interlocutor_id/delete'),
        ACTIVE_INTERLOCUTOR: buildEndpoint('interlocutors/interlocutors/:id/active'),
        GET_INTERLOCUTOR_BY_PROVIDER_AND_SERVICE: buildEndpoint('interlocutors/interlocutors/:dispatch_program_id/:provider_id/:service_id/get-by-ps'),
    },

    QUOTE_INVOICING: {
        EDIT_QUOTE_INVOICING: buildEndpoint('quotes/quotes-invoicing/:id/edit'),
        UPDATE_QUOTE_INVOICING: buildEndpoint('quotes/quotes-invoicing/:id/update'),
        GET_QUOTE_INVOICING_BY_QUOTE: buildEndpoint('quotes/quotes-invoicing/:id/by-quote'),
    },

    DISPATCH_PROGRAM_HISTORY:{
        GET_DISPATCH_PROGRAM_HISTORIES_BY_DISPATCH_PROGRAM: buildEndpoint(
            'dispatch-programs/dispatch-program-history/:dispatch_program_id')
    },

    BUSINESS_NAMES: {
        GET_BUSINESS_NAMES: buildEndpoint('business-names/business-names'),
        CREATE_BUSINESS_NAME: buildEndpoint('business-names/business-names/create'),
        STORE_BUSINESS_NAME: buildEndpoint('business-names/business-names/store'),
        EDIT_BUSINESS_NAME: buildEndpoint('business-names/business-names/:id/edit'),
        SHOW_BUSINESS_NAME: buildEndpoint('business-names/business-names/:id/show'),
        UPDATE_BUSINESS_NAME: buildEndpoint('business-names/business-names/:id/update'),
        DELETE_BUSINESS_NAME: buildEndpoint('business-names/business-names/:id/delete'),
        ACTIVE_BUSINESS_NAME: buildEndpoint('business-names/business-names/:id/active'),
        GET_BUSINESS_NAMES_BY_ENTITY: buildEndpoint('business-names/business-names/:entity/by-entity'),
    },

    BUSINESS_NAME_CONTACTS: {
        GET_ALL_BUSINESS_NAME_CONTACTS: buildEndpoint('contacts/contacts'),
        GET_ALL_BUSINESS_NAME_CONTACTS_BY_BUSINESS_NAME: buildEndpoint('contacts/contacts/:business_name_id/by-business-name'),
        GET_ALL_BUSINESS_NAME_CONTACTS_BY_CLIENT: buildEndpoint('contacts/contacts/:client_id/by-client'),
        GET_ALL_BUSINESS_NAME_CONTACTS_BY_PROVIDER: buildEndpoint('contacts/contacts/:provider_id/by-provider'),
        GET_ALL_BUSINESS_NAME_CONTACTS_BY_SOCIETY: buildEndpoint('contacts/contacts/:society_id/by-society'),
        CREATE_BUSINESS_NAME_CONTACT: buildEndpoint('contacts/contacts/create'),
        STORE_BUSINESS_NAME_CONTACT: buildEndpoint('contacts/contacts/store'),
        EDIT_BUSINESS_NAME_CONTACT: buildEndpoint('contacts/contacts/:id/edit'),
        SHOW_BUSINESS_NAME_CONTACT: buildEndpoint('contacts/contacts/:id/show'),
        UPDATE_BUSINESS_NAME_CONTACT: buildEndpoint('contacts/contacts/:id/update'),
        DELETE_BUSINESS_NAME_CONTACT: buildEndpoint('contacts/contacts/:id/delete'),
        ACTIVE_BUSINESS_NAME_CONTACT: buildEndpoint('contacts/contacts/:id/active'),
        GET_BUSINESS_NAME_CONTACT_BY_CLIENT: buildEndpoint('contacts/contacts/:client_id/get-by-client'),
        GET_BUSINESS_NAME_CONTACT_BY_PROVIDER: buildEndpoint('contacts/contacts/:provider_id/get-by-provider'),
        GET_BUSINESS_NAME_CONTACTS_BY_BUSINESS_NAME: buildEndpoint('contacts/contacts/:business_name_id/get-by-business-name'),
    },

    BANK_ACCOUNT_BUSINESS_NAME: {
        GET_ALL_BUSINESS_NAME_BANK_ACCOUNTS: buildEndpoint('banks/bank-accounts'),
        GET_ALL_BUSINESS_NAME_BANK_ACCOUNTS_BY_BUSINESS_NAME: buildEndpoint('banks/bank-accounts/:business_name_id/by-business-name'),
        GET_ALL_BUSINESS_NAME_BANK_ACCOUNTS_BY_CLIENT: buildEndpoint('banks/bank-accounts/:client_id/by-client'),
        GET_ALL_BUSINESS_NAME_BANK_ACCOUNTS_BY_PROVIDER: buildEndpoint('banks/bank-accounts/:provider_id/by-provider'),
        GET_ALL_BUSINESS_NAME_BANK_ACCOUNTS_BY_SOCIETY: buildEndpoint('banks/bank-accounts/:society_id/by-society'),
        CREATE_BUSINESS_NAME_BANK_ACCOUNT: buildEndpoint('banks/bank-accounts/create'),
        STORE_BUSINESS_NAME_BANK_ACCOUNT: buildEndpoint('banks/bank-accounts/store'),
        EDIT_BUSINESS_NAME_BANK_ACCOUNT: buildEndpoint('banks/bank-accounts/:id/edit'),
        UPDATE_BUSINESS_NAME_BANK_ACCOUNT: buildEndpoint('banks/bank-accounts/:id/update'),
        DELETE_BUSINESS_NAME_BANK_ACCOUNT: buildEndpoint('banks/bank-accounts/:id/delete'),
        ACTIVE_BUSINESS_NAME_BANK_ACCOUNT: buildEndpoint('banks/bank-accounts/:id/active'),
        SHOW_BUSINESS_NAME_BANK_ACCOUNT: buildEndpoint('banks/bank-accounts/:id/show'),
        GET_BUSINESS_NAME_BANK_ACCOUNT_BY_BUSINESS_NAME_AND_BANK_ACCOUNT_REASON: buildEndpoint(
            'banks/bank-accounts/:business_name_id/:bank_account_reason_id/by-business-account'),
    },

    CONTACT_TYPE: {
        GET_CONTACT_TYPES: buildEndpoint('contacts/contact-types'),
        STORE_CONTACT_TYPE: buildEndpoint('contacts/contact-types/store'),
        EDIT_CONTACT_TYPE: buildEndpoint('contacts/contact-types/:id/edit'),
        CREATE_CONTACT_TYPE: buildEndpoint('contacts/contact-types/create'),
        SHOW_CONTACT_TYPE: buildEndpoint('contacts/contact-types/:id/show'),
        UPDATE_CONTACT_TYPE: buildEndpoint('contacts/contact-types/:id/update'),
        DELETE_CONTACT_TYPE: buildEndpoint('contacts/contact-types/:id/delete'),
        ACTIVE_CONTACT_TYPE: buildEndpoint('contacts/contact-types/:id/active'),
    },

    ITEM_CATEGORIES: {
        GET_ITEM_CATEGORIES: buildEndpoint('products/item-categories'),
        STORE_ITEM_CATEGORY: buildEndpoint('products/item-categories/store'),
        EDIT_ITEM_CATEGORY: buildEndpoint('products/item-categories/:id/edit'),
        UPDATE_ITEM_CATEGORY: buildEndpoint('products/item-categories/:id/update'),
        DELETE_ITEM_CATEGORY: buildEndpoint('products/item-categories/:id/delete'),
        ACTIVE_ITEM_CATEGORY: buildEndpoint('products/item-categories/:id/active'),
    },

    LOCATIONS: {
        GET_LOCATIONS: buildEndpoint('products/locations'),
        STORE_LOCATION: buildEndpoint('products/locations/store'),
        EDIT_LOCATION: buildEndpoint('products/locations/:id/edit'),
        UPDATE_LOCATION: buildEndpoint('products/locations/:id/update'),
        DELETE_LOCATION: buildEndpoint('products/locations/:id/delete'),
        ACTIVE_LOCATION: buildEndpoint('products/locations/:id/active'),
    },

    SECTORS: {
        GET_SECTORS: buildEndpoint('products/sectors'),
        STORE_SECTOR: buildEndpoint('products/sectors/store'),
        EDIT_SECTOR: buildEndpoint('products/sectors/:id/edit'),
        UPDATE_SECTOR: buildEndpoint('products/sectors/:id/update'),
        DELETE_SECTOR: buildEndpoint('products/sectors/:id/delete'),
        ACTIVE_SECTOR: buildEndpoint('products/sectors/:id/active'),
    },

    QUALITIES: {
        GET_QUALITIES: buildEndpoint('products/qualities'),
        STORE_QUALITY: buildEndpoint('products/qualities/store'),
        EDIT_QUALITY: buildEndpoint('products/qualities/:id/edit'),
        UPDATE_QUALITY: buildEndpoint('products/qualities/:id/update'),
        DELETE_QUALITY: buildEndpoint('products/qualities/:id/delete'),
        ACTIVE_QUALITY: buildEndpoint('products/qualities/:id/active'),
    },

    COLORS: {
        GET_COLORS: buildEndpoint('products/colors'),
        STORE_COLOR: buildEndpoint('products/colors/store'),
        EDIT_COLOR: buildEndpoint('products/colors/:id/edit'),
        UPDATE_COLOR: buildEndpoint('products/colors/:id/update'),
        DELETE_COLOR: buildEndpoint('products/colors/:id/delete'),
        ACTIVE_COLOR: buildEndpoint('products/colors/:id/active'),
    },
    SALES_ORDERS: {
        GET_SALES_ORDERS: buildEndpoint('sales-orders/sales-orders'),
        CREATE_SALES_ORDER: buildEndpoint('sales-orders/sales-orders/create'),
        STORE_SALES_ORDER: buildEndpoint('sales-orders/sales-orders/store'),
        EDIT_SALES_ORDER: buildEndpoint('sales-orders/sales-orders/:id/edit'),
        UPDATE_SALES_ORDER: buildEndpoint('sales-orders/sales-orders/:id/update'),
        SHOW_SALES_ORDER: buildEndpoint('sales-orders/sales-orders/:id/show'),
        DELETE_SALES_ORDER: buildEndpoint('sales-orders/sales-orders/:id/delete'),
        ACTIVE_SALES_ORDER: buildEndpoint('sales-orders/sales-orders/:id/active'),
        GET_CLIENTS_BY_SOCIETY: buildEndpoint('sales-orders/sales-orders/societies/:society_id/clients'),
    },
    SALES_ORDER_DETAILS: {
        GET_SALES_ORDER_DETAILS: buildEndpoint('sales-orders/sales-order-details'),
        EDIT_SALES_ORDER_DETAIL: buildEndpoint('sales-orders/sales-order-details/:id/edit'),
        STORE_SALES_ORDER_DETAIL: buildEndpoint('sales-orders/sales-order-details/store'),
        UPDATE_SALES_ORDER_DETAIL: buildEndpoint('sales-orders/sales-order-details/:id/update'),
        DELETE_SALES_ORDER_DETAIL: buildEndpoint('sales-orders/sales-order-details/:id/delete'),
    },
    CLIENT_CONTACTS: {
        GET_CLIENT_CONTACTS_BY_CLIENT: buildEndpoint('contacts/client-contacts/:client_id/by-client'),
    },
    DELIVERIES: {
        GET_DELIVERIES: buildEndpoint('deliveries/deliveries'),
        CREATE_DELIVERY: buildEndpoint('deliveries/deliveries/create'),
        STORE_DELIVERY: buildEndpoint('deliveries/deliveries/store'),
        EDIT_DELIVERY: buildEndpoint('deliveries/deliveries/:id/edit'),
        SHOW_DELIVERY: buildEndpoint('deliveries/deliveries/:id/show'),
        UPDATE_DELIVERY: buildEndpoint('deliveries/deliveries/:id/update'),
        DELETE_DELIVERY: buildEndpoint('deliveries/deliveries/:id/delete'),
        CHANGE_STATUS_DELIVERY: buildEndpoint('deliveries/deliveries/:id/change-status'),
        GET_DELIVERIES_BY_SOCIETY_CLIENT: buildEndpoint('deliveries/deliveries/by-society-client/:society_id/:client_id'),
    },
    DELIVERY_DETAILS: {
        GET_DELIVERY_DETAILS: buildEndpoint('deliveries/deliveries/:delivery_id/details'),
        STORE_DELIVERY_DETAIL: buildEndpoint('deliveries/deliveries/:delivery_id/details/store'),
        EDIT_DELIVERY_DETAIL: buildEndpoint('deliveries/deliveries/:delivery_id/details/:id/edit'),
        UPDATE_DELIVERY_DETAIL: buildEndpoint('deliveries/deliveries/:delivery_id/details/:id/update'),
        DELETE_DELIVERY_DETAIL: buildEndpoint('deliveries/deliveries/:delivery_id/details/:id/delete'),
    }
};
